// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:00:28.176Z
// Property: Atlantic on the Avenue (ID: 6767906449166427)
// Collections: 24 amenities, 10 floorplans (live), 24 photos, 53 POIs, 4 reviews, 10 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166427",
  "property_external_id": "nsg7yjq",
  "property_zillow_url": "https://www.zillow.com/apartments/north-charleston-sc/atlantic-on-the-avenue/CjjCCJ/",
  "property_apartments_url": "https://www.apartments.com/atlantic-on-the-avenue-north-charleston-sc/nsg7yjq/",
  "property_google_business_url": "https://www.google.com/maps/place/Atlantic+on+the+Avenue/data=!4m2!3m1!1s0x0:0x82733e8fc76519e0?sa=X&ved=2ahUKEwippbaT4aeSAxW46ckDHU0eHDMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40256880238",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "832ATA",
  "property_status": null,
  "property_slug": "atlantic-on-the-avenue",
  "property_name": "Atlantic on the Avenue",
  "property_website_url": "http://www.atlanticontheavenue.com/",
  "property_domain": "https://www.atlanticontheavenue.com/",
  "property_address": "6880 Rivers Avenue",
  "property_full_address": "6880 Rivers Ave, North Charleston, SC 29406",
  "property_address_1": "6880 Rivers Ave",
  "property_address_2": null,
  "property_address_city": "North Charleston",
  "property_address_state": "SC",
  "property_address_zip_full": null,
  "property_address_zip": "29406",
  "property_address_country": "US",
  "property_address_county": "Charleston County",
  "property_neighborhood_address": "North Charleston",
  "property_address_latitude": "32.9211302",
  "property_address_longitude": "-80.0292856",
  "property_email": null,
  "property_phone": "(843) 410-4955",
  "property_call_tracking_phone": "855-481-6172",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Atlantic on the Avenue in North Charleston, SC, modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans featuring chef-inspired kitchens and wood plank flooring. Enjoy premium amenities like a resort-style pool, business center, and pet park. Your perfect home awaits—browse availability or schedule a tour!",
  "property_long_description": "Welcome to Atlantic on the Avenue, where modern living meets southern charm in the heart of North Charleston, SC. Our stunning apartment community offers a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options, perfect for any lifestyle. Each apartment features open concept layouts, complete with chef-inspired kitchens adorned with espresso cabinetry, modern fixtures, and spacious walk-in closets. Enjoy the comfort of your own washer and dryer, along with beautiful wood plank-style flooring and ceiling fans to keep your living space cool.\n\nAt Atlantic on the Avenue, you'll discover a wealth of amenities designed to enhance your everyday life. Dive into our resort-style pool for a refreshing escape or unwind in our inviting clubroom, complete with a TV and a demonstration kitchen perfect for social gatherings. Our 24/7 fitness center ensures you stay active at your convenience, while our business center provides an ideal space for remote work. Pet owners will love our pet-friendly community, which features a dedicated pet park and spacious patios and balconies for your furry friends to enjoy.\n\nWith convenient package lockers for all your deliveries and a gas grilling station for weekend cookouts, Atlantic on the Avenue provides everything you need to feel right at home. Ready to elevate your living experience? Find your new home today—browse our availability or schedule a tour to visit our vibrant community. We can't wait to welcome you to Atlantic on the Avenue!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f669d-f4da-725e-b2ae-56315b95eec9.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019f669d-f4da-725e-b2ae-56315b95eec9",
    "storage_key": "property/6767906449166427/019f669d-f4da-725e-b2ae-56315b95eec9.webp",
    "width": 1280,
    "height": 854
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166427/019ffc39-3386-7078-a40d-934a0d604d8d.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-3386-7078-a40d-934a0d604d8d",
    "storage_key": "property/6767906449166427/019ffc39-3386-7078-a40d-934a0d604d8d.m4v",
    "thumbnail_key": "property/6767906449166427/019ffc39-3386-7078-a40d-934a0d604d8d_thumb.webp",
    "size_bytes": 26251937,
    "classification": "Apartment",
    "title": "Modern Apartment Interiors and Community Amenities",
    "description": "Explore the stylish interiors of our apartments, including kitchens and living spaces, alongside community features like the pool and garages."
  },
  "property_total_units": "202",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.5940594059406",
  "property_admin_fee": "200",
  "property_application_fee": "80",
  "property_fees_deposit_info": "$350-1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit (cats or small dogs).",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum of 2 pets per unit (cats or small dogs). Pet deposit: $300 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://atlanticontheavenue.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcatlanticontheavenue",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c9-ee2b-7548-8019-e923bef6dae0.webp",
  "property_primary_logo_media": {
    "alt_text": "Atlantic on the Avenue logo",
    "public_id": "019d02c9-ee2b-7548-8019-e923bef6dae0",
    "storage_key": "property/6767906449166427/019d02c9-ee2b-7548-8019-e923bef6dae0.webp",
    "width": 291,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c9-dbc0-765e-9be8-f50ed28d15a6.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c9-dbc0-765e-9be8-f50ed28d15a6",
    "storage_key": "property/6767906449166427/019d02c9-dbc0-765e-9be8-f50ed28d15a6.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02ca-03ea-749c-a241-5d3ac361d689.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Atlantic on the Avenue logo.",
    "public_id": "019d02ca-03ea-749c-a241-5d3ac361d689",
    "storage_key": "property/6767906449166427/019d02ca-03ea-749c-a241-5d3ac361d689.webp",
    "width": 291,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02ca-0b6e-70dd-a26c-311cd35ecade.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Atlantic on the Avenue logo",
    "public_id": "019d02ca-0b6e-70dd-a26c-311cd35ecade",
    "storage_key": "property/6767906449166427/019d02ca-0b6e-70dd-a26c-311cd35ecade.webp",
    "width": 291,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "651 - 1434",
  "property_sqft_min": "651",
  "property_sqft_max": "1434",
  "property_price_range": "$1486 - $2304",
  "property_price_min": "1486",
  "property_price_max": "2304",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/AtlanticOnTheAvenue/",
  "property_instagram_url": "https://www.instagram.com/atlanticontheave/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJB3awQpZj_ogR4Bllx48-c4I",
  "property_youtube_url": "https://www.youtube.com/watch?v=e46rSv6FcDI",
  "property_yelp_url": "https://www.yelp.com/biz/atlantic-on-the-boulevard-north-charleston-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Atlantic on the Avenue",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Atlantic on the Avenue in North Charleston, where modern living meets comfort. Choose from one, two, or three-bedroom designs featuring chef-inspired kitchens, spacious patios, and resort-style amenities. With a pet-friendly environment and a vibrant clubroom, your ideal lifestyle awaits. Dive into our exceptional community today!",
  "property_home_floorplans_blurb": "At Atlantic on the Avenue in North Charleston, SC, your ideal living space awaits. With thoughtfully designed one, two, and three-bedroom apartments, each floor plan seamlessly blends comfort and style. Browse our available homes today and step into a lifestyle tailored just for you!",
  "property_home_gallery_blurb": "Welcome to Atlantic on the Avenue in North Charleston, SC, where modern living meets comfort. Choose from stylish one, two, or three-bedroom floor plans boasting chef-inspired kitchens and spacious patios. Enjoy top-notch amenities like a resort-style pool and pet-friendly spaces. Picture yourself living here, where every detail matters!",
  "property_home_neighborhood_blurb": "Welcome to Atlantic on the Avenue, where stylish living meets vibrant community life in North Charleston. Enjoy easy access to local gems like the North Charleston Coliseum, Whirlin' Waters Adventure Waterpark, and picturesque Riverfront Park. Your new home is perfectly situated near entertainment and recreation, creating the ideal blend of comfort and adventure.",
  "property_home_reviews_blurb": "At Atlantic on the Avenue, our residents rave about the seamless living experience and dedicated staff. With beautifully renovated apartments, an onsite gym, and top-notch maintenance, you're never just a tenant—you're part of a community. Join us and see why our residents feel so welcomed and satisfied!",
  "property_neighborhood_blurb": "Nestled in North Charleston, Atlantic on the Avenue offers a vibrant lifestyle surrounded by adventure. From exploring Whirlin' Waters Adventure Waterpark to relaxing at Riverfront Park, your free time shines. Close by, you'll find enriching venues like Charleston Southern University and the North Charleston Coliseum, ensuring fun and culture are just steps away.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Atlantic on the Avenue in North Charleston, SC, indulge in vibrant living with open-concept layouts and chef-inspired kitchens. Our pet-friendly community boasts a resort-style pool, 24/7 fitness center, and stylishly designed spaces — all complemented by spacious patios and modern finishes. Elevate your lifestyle today!",
  "property_applynow_blurb": "At Atlantic on the Avenue in North Charleston, SC, your perfect home awaits. Choose from stylish one, two, or three-bedroom floor plans featuring open layouts, chef-inspired kitchens, and spacious patios. Enjoy amenities like a resort-style pool, a pet park, and a 24/7 fitness center. Lease online today to start your new chapter!",
  "property_contactus_blurb": "At Atlantic on the Avenue in North Charleston, SC, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Whether you're seeking a cozy retreat or a spacious family home, our community caters to your unique lifestyle. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Atlantic on the Avenue in North Charleston, SC, our diverse floor plans—ranging from one to three bedrooms—cater to every lifestyle. Curious about community life? Browse our FAQs page for insights and answers to your top inquiries, ensuring you feel right at home before you even step through the door.",
  "property_floorplans_blurb": "At Atlantic on the Avenue in vibrant North Charleston, SC, choose from thoughtfully designed one, two, and three-bedroom apartments tailored to fit your lifestyle. With spacious layouts and modern amenities, your ideal home awaits. Browse our available floor plans today and redefine your living experience!",
  "property_gallery_blurb": "At Atlantic on the Avenue in North Charleston, SC, elegance meets comfort. From chef-inspired kitchens to spacious patios, each detail enhances your lifestyle. Whether you prefer a cozy one-bedroom or a roomy three-bedroom, our community boasts resort-style amenities and a welcoming pet park. Picture yourself living here!",
  "property_interactivemap_blurb": "At Atlantic on the Avenue in North Charleston, SC, find your perfect home in our diverse floor plans, from modern one-bedroom to spacious three-bedroom apartments. Revel in upscale amenities like a resort-style pool, pet park, and chef-inspired kitchens. Use our interactive map to explore your new vibrant community!",
  "property_pets_blurb": "At Atlantic on the Avenue in North Charleston, SC, your furry friends are part of the family! With a welcoming environment for up to two cats or small dogs, you can enjoy the vibrant community while knowing your pets have a cozy place to call home. Live life unleashed!",
  "property_referafriend_blurb": "At Atlantic on the Avenue in North Charleston, SC, our diverse floor plans—offering one, two, and three bedrooms—provide the perfect space for you and your friends. Share the experience of upscale living and vibrant community. Great friends make great neighbors; refer a friend today and enhance your lifestyle together!",
  "property_residentaccess_blurb": "At Atlantic on the Avenue in North Charleston, SC, our thoughtfully designed one, two, and three-bedroom floor plans cater to every lifestyle. Stay connected and in control with easy access to your resident portal—manage rent, schedule maintenance, and enhance your living experience from the comfort of your home.",
  "property_reviews_blurb": "At Atlantic on the Avenue in North Charleston, our residents rave about their seamless experiences and attentive staff. With a beautiful, well-maintained facility, our leasing agents, like Alex, excel in providing personalized care. Join a community where \"staff clearly take pride in the upkeep of their complex,\" making it a true home!",
  "property_created_at": "1759782543374",
  "property_scheduletour_blurb": "At Atlantic on the Avenue in North Charleston, SC, choose from spacious one, two, or three-bedroom floor plans designed to elevate your living experience. Imagine your new home surrounded by vibrant community energy. Curious about resident experiences? Schedule a tour today and see for yourself!",
  "property_thankyou_blurb": "Thank you for reaching out! At Atlantic on the Avenue in North Charleston, SC, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. A member of our team will connect with you soon to help you find your perfect home. Your journey begins here!",
  "property_virtualtours_blurb": "At Atlantic on the Avenue in North Charleston, SC, your perfect home awaits. Choose from stylish one, two, or three-bedroom floor plans, thoughtfully designed for comfort and convenience. Immerse yourself in our vibrant community—take a virtual tour today and envision your new lifestyle in this inviting haven!",
  "property_copyright": "2025 All Rights Reserved. Atlantic on the Avenue",
  "property_seo_title_home": "Atlantic on the Avenue | Apartments in North Charleston",
  "property_seo_description_home": "Located in North Charleston, we offer 1, 2, & 3-bedroom pet-friendly apartments for rent. Come home to our luxury apartments!",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3 Bedroom Apartments Charleston, SC",
  "property_seo_description_floorplans": "Atlantic on the Avenue offers 1, 2, & 3-bedroom apartments with modern comfort in Charleston, SC. Browse our apartments for rent now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in Charleston, SC",
  "property_seo_description_amenities": "Located in North Charleston, Atlantic on the Avenue offers 1, 2, & 3-bedroom apartments with luxury interiors & resort-style amenities.",
  "property_seo_title_gallery": "Gallery | Apartments For Rent in North Charleston",
  "property_seo_description_gallery": "View our pet-friendly apartments for rent in Charleston, SC, through our photos. Explore apartment interiors, amenities, & more. Take a look at the photos now!",
  "property_seo_title_virtualtours": "Virtual Tours | Charleston Apartments For Rent",
  "property_seo_description_virtualtours": "Discover your new home at Atlantic on the Avenue! Take a virtual tour of our floor plans, amenities, & more. Start your tour now in Charleston, SC!",
  "property_seo_title_interactivemap": "Map | Apartments in North Charleston",
  "property_seo_description_interactivemap": "Atlantic on the Avenue is in North Charleston, SC, near Riverfront Park, the Magnolia Plantation, & Audubon Swamp Garden. View our map of our apartments!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Charleston",
  "property_seo_description_neighborhood": "Atlantic on the Avenue is in North Charleston, SC, near Riverfront Park, the Magnolia Plantation, & Audubon Swamp Garden. Come in for a tour of our apartments!",
  "property_seo_title_contact": "Contact Us | North Charleston Apartments for Rent",
  "property_seo_description_contact": "Have questions about our Charleston apartments for rent or want to schedule a tour? Our amazing leasing team is ready to help! Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in North Charleston, SC",
  "property_seo_description_faqs": "Find quick answers to your questions about Atlantic on the Avenue in North Charleston, SC. Unlock the lifestyle you deserve in our pet-friendly community!",
  "property_seo_title_reviews": "Reviews | Apartments in Charleston, SC",
  "property_seo_description_reviews": "Explore feedback from residents of Atlantic on the Avenue! Learn firsthand experiences and gain insights into our vibrant apartment community in Charleston, SC.",
  "property_seo_title_applynow": "Apply Now | 1, 2, & 3 Bedroom Charleston, SC Apartments",
  "property_seo_description_applynow": "Apply online for our 1, 2, & 3-bedroom apartments for rent in Charleston, SC. Complete the application today!",
  "property_seo_title_residentaccess": "Resident Access | Charleston Apartments for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments in Charleston, SC",
  "property_seo_description_referafriend": "Refer a friend to Atlantic on the Avenue and both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Charleston, SC",
  "property_seo_description_scheduletour": "Ready to explore Atlantic on the Avenue firsthand? Book a tour and uncover our amenities and 1, 2, & 3-bedroom apartments in Charleston, SC!",
  "property_seo_title_privacy": "Privacy Policy | Atlantic on the Avenue",
  "property_seo_description_privacy": "Your privacy matters at Atlantic on the Avenue! Dive into our policy to learn how we protect your information while you enjoy life in North Charleston, SC.",
  "property_seo_title_accessibility": "Website Accessibility | Atlantic on the Avenue",
  "property_seo_description_accessibility": "Experience seamless living at Atlantic on the Avenue in North Charleston, SC. We prioritize digital inclusion for all residents. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Atlantic on the Avenue",
  "property_seo_description_sitemap": "Uncover a world of convenience at Atlantic on the Avenue in North Charleston, SC. Navigate through our sitemap for a seamless living experience today!",
  "property_seo_title_thankyou": "Thank You | Apartments for Rent in Charleston, SC",
  "property_seo_description_thankyou": "Thank you for your interest in Atlantic on the Avenue. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pets | Pet Friendly Apartments in North Charleston, SC",
  "property_seo_description_pets": "Atlantic on the Avenue offers the best pet-friendly living in North Charleston. Check out our pet policy today!",
  "property_updated_at": "1786643039014",
  "amenities": [
    {
      "id": "custom_413fdd09-eddb-42bf-95f3-a88f7dfec7a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_8addab44-a175-4745-b5b1-3b3387e3baac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_8a281307-7b6b-45de-b4a1-7f4a02d1201f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ccb8868e-7f5d-47da-bdc4-182ec81941cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6b0e7237-f0df-485c-a712-0cc49e822540",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a95488a1-bced-4229-aaa1-5143dfc6879d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Clubroom w/ TV + Demonstration Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0a52186e-44b3-4a0b-b81c-28b7b94ddc39",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c1f5c21d-88ae-428a-b216-0841a77491ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Grilling Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_37a04836-5464-44db-86a0-0ed6afcd2f94",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_18a2a3b2-0e6b-41a3-94d9-f967ae4c4aa0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Professional & Responsive Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e3c73c3e-4d6b-4a6d-84dc-b5168d044996",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_62486844-f2e9-4bb2-aca2-4c0413ab7483",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2f8da016-b311-413e-b787-9f075b7c6a39",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9c745c99-7b97-4782-bad7-534ca9cdd298",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer In Unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b4cf8b67-ba6c-479d-8668-9e3ee6adf710",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Open Concept Layouts",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_82aa87ac-be95-47b4-90b0-93a0c7d560c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Fixtures + Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_64b8de3d-1f29-4a2f-a91c-6d196906f7a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plank Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_27f4fc21-c933-4a19-b295-d91088dddfe5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans in Living Room + Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1adccda8-ef84-4be3-b1e0-f4d0582759bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Chef Inspired Kitchens w/ Espresso Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3d6e2e73-4d80-41f4-a6cb-1b90ac47ceec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Patios + Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_88c47fe6-0152-428c-af5f-cbcee8b43008",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f7bdad8b-96fa-47eb-8a46-5ed14877f48b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a0d56281-5fcb-478c-9678-cca86fa3d237",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_29ddbbec-9cb0-468f-95af-998055d30094",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b57b370f-aed5-4164-a64b-40dadad0258b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-1ad9-7178-ba3b-0d73885ec995.webp",
      "image_media": {
        "alt_text": "Atlantic on the Avenue Apartments monument sign and building exterior.",
        "public_id": "01a010a5-1ad9-7178-ba3b-0d73885ec995",
        "storage_key": "property/6767906449166427/01a010a5-1ad9-7178-ba3b-0d73885ec995.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Atlantic on the Avenue Apartments, featuring a modern building exterior and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Atlantic on the Avenue Apartments monument sign and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_127282a8-6bb9-4877-9cef-bcb42b82b9b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-1d99-749c-90dd-d2ff5ea4a1ad.webp",
      "image_media": {
        "alt_text": "Building entrance with a modern architectural design featuring a wooden overhang and bright blue siding at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-1d99-749c-90dd-d2ff5ea4a1ad",
        "storage_key": "property/6767906449166427/01a010a5-1d99-749c-90dd-d2ff5ea4a1ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community's beautifully designed building entrance, complete with a striking wooden overhang and vibrant blue siding.",
      "link": "",
      "alt_text": "Building entrance with a modern architectural design featuring a wooden overhang and bright blue siding at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2a6e19d-2703-4aac-ac94-5f33eec97ed6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-1d75-7308-a668-70a25cc8a5a8.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment building exterior with a parking lot and trees at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-1d75-7308-a668-70a25cc8a5a8",
        "storage_key": "property/6767906449166427/01a010a5-1d75-7308-a668-70a25cc8a5a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building with a mix of teal and white siding, featuring numerous balconies and a surrounding parking lot, set against a backdrop of lush green trees.",
      "link": "",
      "alt_text": "Aerial view of a large apartment building exterior with a parking lot and trees at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_808d2663-7e2b-4e12-be1e-4ed9e45e8d0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-090a-771b-a707-38cd39319798.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a parking lot at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-090a-771b-a707-38cd39319798",
        "storage_key": "property/6767906449166427/01a010a5-090a-771b-a707-38cd39319798.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A view of the exterior of the apartment building, showcasing its modern design with balconies and surrounding landscaping, along with a parking area.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and a parking lot at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1d6ea66-3788-477a-a1df-baad7df3ce2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-2518-765f-8b4a-fa5ed7d20940.webp",
      "image_media": {
        "alt_text": "Bright and airy lobby with double doors, large windows, and modern decor.",
        "public_id": "01a010a5-2518-765f-8b4a-fa5ed7d20940",
        "storage_key": "property/6767906449166427/01a010a5-2518-765f-8b4a-fa5ed7d20940.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the beautifully designed lobby, featuring elegant lighting, contemporary artwork, and spacious seating areas, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Bright and airy lobby with double doors, large windows, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8359b4ec-04ba-4396-9725-3685a2007934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-0356-75cc-b470-fbfbd0fed39b.webp",
      "image_media": {
        "alt_text": "Community kitchen with a long island and blue bar stools at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-0356-75cc-b470-fbfbd0fed39b",
        "storage_key": "property/6767906449166427/01a010a5-0356-75cc-b470-fbfbd0fed39b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy cooking and gathering in our stylish community kitchen, featuring modern appliances and a large island perfect for entertaining.",
      "link": "",
      "alt_text": "Community kitchen with a long island and blue bar stools at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a5c7fea-ffe5-43d9-a424-d07b7b5ec555",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a4-ff97-77cb-b179-08969d9d3831.webp",
      "image_media": {
        "alt_text": "Community kitchen with a large wooden island and bar stools, stainless steel appliances, and dark cabinets.",
        "public_id": "01a010a4-ff97-77cb-b179-08969d9d3831",
        "storage_key": "property/6767906449166427/01a010a4-ff97-77cb-b179-08969d9d3831.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the spacious island in our community kitchen, perfect for socializing or enjoying a casual meal. Features modern appliances and comfortable seating.",
      "link": "",
      "alt_text": "Community kitchen with a large wooden island and bar stools, stainless steel appliances, and dark cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_110b149a-72f9-461d-82a2-ca2c793b393d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-0045-760b-b1b9-9bf176a73538.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace, large windows, and abstract art.",
        "public_id": "01a010a5-0045-760b-b1b9-9bf176a73538",
        "storage_key": "property/6767906449166427/01a010a5-0045-760b-b1b9-9bf176a73538.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish communal living area featuring a contemporary fireplace, comfortable seating, and beautiful abstract artwork.",
      "link": "",
      "alt_text": "Modern living room with fireplace, large windows, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21163d6a-f8dd-4b3e-b247-ab4718796b18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-2500-73ce-bb9d-8f4c7cee3910.webp",
      "image_media": {
        "alt_text": "Business center with two computers and a printer at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-2500-73ce-bb9d-8f4c7cee3910",
        "storage_key": "property/6767906449166427/01a010a5-2500-73ce-bb9d-8f4c7cee3910.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our convenient business center, equipped with computers and a printer for all your work needs.",
      "link": "",
      "alt_text": "Business center with two computers and a printer at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b38ac5a9-9714-4f37-b240-53f86af4386d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-2896-7767-b11c-45bb98142986.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and exercise balls at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-2896-7767-b11c-45bb98142986",
        "storage_key": "property/6767906449166427/01a010a5-2896-7767-b11c-45bb98142986.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and exercise balls at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9c90922-89dd-4d42-a58e-dc244ffecc3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-3a8b-703d-ae22-b617b37ed448.webp",
      "image_media": {
        "alt_text": "Gym equipment including weight machines and dumbbells, with mirrors on the wall.",
        "public_id": "01a010a5-3a8b-703d-ae22-b617b37ed448",
        "storage_key": "property/6767906449166427/01a010a5-3a8b-703d-ae22-b617b37ed448.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring modern weight machines, free weights, and cardio equipment to help you achieve your fitness goals.",
      "link": "",
      "alt_text": "Gym equipment including weight machines and dumbbells, with mirrors on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8160763-b872-4595-a072-39f9c8e5c7ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-16e1-7774-94d2-71474bf162d7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas  at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-16e1-7774-94d2-71474bf162d7",
        "storage_key": "property/6767906449166427/01a010a5-16e1-7774-94d2-71474bf162d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas  at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93033c19-71a6-423e-bf0a-c52550ef36b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-18f8-720d-870c-4e2bf7539180.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
        "public_id": "01a010a5-18f8-720d-870c-4e2bf7539180",
        "storage_key": "property/6767906449166427/01a010a5-18f8-720d-870c-4e2bf7539180.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, surrounded by lush landscaping and modern apartment living.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de767fd9-1df3-4f36-9c6a-e5e2ca9deb86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-6197-77e8-a05d-8bc92722d010.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "01a010a5-6197-77e8-a05d-8bc92722d010",
        "storage_key": "property/6767906449166427/01a010a5-6197-77e8-a05d-8bc92722d010.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af152eaf-a917-49f4-8ec6-b96f8cf10fa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-5e07-725e-86a1-195dd3a1fa86.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and palm trees at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-5e07-725e-86a1-195dd3a1fa86",
        "storage_key": "property/6767906449166427/01a010a5-5e07-725e-86a1-195dd3a1fa86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs, tropical palm trees, and a shaded outdoor bar area.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and palm trees at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2bdd174-af7e-455f-be53-55d5185899ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-204f-748c-8a12-7c89d68d5ea5.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with bar and grill under a wooden pergola.",
        "public_id": "01a010a5-204f-748c-8a12-7c89d68d5ea5",
        "storage_key": "property/6767906449166427/01a010a5-204f-748c-8a12-7c89d68d5ea5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain guests in the outdoor lounge area featuring a full-service bar, grill, and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor seating area with bar and grill under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c65663e1-b92a-437b-9139-a1d556e31838",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4702-768a-8988-9888489fa19a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4702-768a-8988-9888489fa19a",
        "storage_key": "property/6767906449166427/01a010a5-4702-768a-8988-9888489fa19a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, elegant granite countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d461b9a5-2743-40ed-a380-fada477563ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4721-777e-9f05-5b8541c22f79.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with granite countertops, dark wood cabinets, and blue chairs at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4721-777e-9f05-5b8541c22f79",
        "storage_key": "property/6767906449166427/01a010a5-4721-777e-9f05-5b8541c22f79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this stylish apartment kitchen, featuring granite countertops, ample cabinet space, and a modern dining area perfect for intimate meals.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with granite countertops, dark wood cabinets, and blue chairs at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a7eb4d7-a151-4297-8905-b55d4c7bad92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-49db-7014-b1d0-205fd9d43194.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with gray sofa, blue chairs, and marble table at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-49db-7014-b1d0-205fd9d43194",
        "storage_key": "property/6767906449166427/01a010a5-49db-7014-b1d0-205fd9d43194.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully furnished apartment, featuring a spacious living area and elegant dining space.",
      "link": "",
      "alt_text": "Modern living and dining area with gray sofa, blue chairs, and marble table at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0209698d-f144-42db-b0f5-d89efb83cb64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4ced-7389-9032-d0f5e38b6b52.webp",
      "image_media": {
        "alt_text": "Stylish living room with gray sofa, accent chair, coffee table, and open-concept kitchen area at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4ced-7389-9032-d0f5e38b6b52",
        "storage_key": "property/6767906449166427/01a010a5-4ced-7389-9032-d0f5e38b6b52.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort and style with this inviting living space, featuring a plush sofa, chic accent chair, and a seamless flow into a modern kitchen.",
      "link": "",
      "alt_text": "Stylish living room with gray sofa, accent chair, coffee table, and open-concept kitchen area at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3045b068-9c73-49d9-bf07-1ecfd63d5599",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4e02-70d1-8ae4-21e9cae2438d.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white linens and blue accent pillows in a bedroom at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4e02-70d1-8ae4-21e9cae2438d",
        "storage_key": "property/6767906449166427/01a010a5-4e02-70d1-8ae4-21e9cae2438d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed with plush white linens and elegant blue accent pillows.",
      "link": "",
      "alt_text": "Queen-size bed with white linens and blue accent pillows in a bedroom at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b753e14-fd2f-4fc4-b16a-a882252c131a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4f30-746c-9604-ec59fa8f4cad.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large wicker headboard and white bedding, featuring a ceiling fan and large windows at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4f30-746c-9604-ec59fa8f4cad",
        "storage_key": "property/6767906449166427/01a010a5-4f30-746c-9604-ec59fa8f4cad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, complete with a plush bed, ceiling fan, and ample natural light from the large windows.",
      "link": "",
      "alt_text": "Cozy bedroom with a large wicker headboard and white bedding, featuring a ceiling fan and large windows at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f771c01a-929a-4260-b19c-b11cc3dee814",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-5073-70fd-8c77-21f3a89b93b4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-5073-70fd-8c77-21f3a89b93b4",
        "storage_key": "property/6767906449166427/01a010a5-5073-70fd-8c77-21f3a89b93b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a granite-top vanity, a modern light fixture, a toilet, and a white bathtub with a shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_900de48a-499b-4dfc-a289-dffa6b0e80a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/01a010a5-4ffc-743e-bdeb-c6912ea0725a.webp",
      "image_media": {
        "alt_text": "Balcony with a bistro set overlooking a courtyard at Atlantic on the Avenue in North Charleston, SC.",
        "public_id": "01a010a5-4ffc-743e-bdeb-c6912ea0725a",
        "storage_key": "property/6767906449166427/01a010a5-4ffc-743e-bdeb-c6912ea0725a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on this private balcony, furnished with a charming bistro set and overlooking the lush courtyard.",
      "link": "",
      "alt_text": "Balcony with a bistro set overlooking a courtyard at Atlantic on the Avenue in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_50131997-12fa-4b9c-a4ee-f02cca7c5de4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "XscapeWorks",
      "poi_type": "Entertainment",
      "poi_address": "2430 Air Park Rd, North Charleston, SC 29406, USA",
      "poi_short_description": "Scary escape room featuring live scare actors alongside zombies, ghosts and creepier scenarios.",
      "poi_long_description": "People say this escape room center offers a unique and immersive experience with challenging puzzles, interactive tasks, and engaging storylines. They highlight the fun, elaborate, and well-thought-out rooms, as well as the impressive attention to detail, special effects, and animatronics. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ09kDI_tj_ogRJZGZXIwCJDo/photos/AcnlKN1lifpU06gwlrYOtwE2mUQsZwV4Ocakv42gWlbS_kZzAD5W8b-55dliteyGWNSDV8_NBtX_-JxY1qjSKiXyRfTFaN7C_kE2JcQfrvjB8KzpWYH4Uhk7LVbIjEcoWna1s3RTqOZF_vKl1lpqqZWoyYfWQafFJ_ijZr1XYFWO-WwdT5d_p94SEsTlTBmTnCLBNU6F9rhSfdNChBznC3Felri6epMu02YATQf2Q2moNBUT-v5_9CfHIoqUIyPj-FQfRHcrtY1nWGwLAEURYe-mX3GkxaawOqr0GbzJ9EeskYh7sg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1920&maxHeightPx=1080",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.xscapeworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4189476355233648933&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "xscapeworks",
      "poi_latitude": "32.8941995",
      "poi_longitude": "-80.0219231",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-9405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09kDI_tj_ogRJZGZXIwCJDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_13d6750c-7022-429a-bde2-366a6c6bf046",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Flight Adventure Park Charleston",
      "poi_type": "Entertainment",
      "poi_address": "8551 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Trampoline park for all ages offering an array of jump options, a ninja warrior course and dodgeball.",
      "poi_long_description": "People say this recreation center offers a variety of fun activities, including a sports court, trampolines, and a ninja warrior course. They highlight the great value, especially with the monthly membership, and the vibrant, energetic atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJryQoZXBh_ogROM0QMO9Ja9o/photos/AcnlKN26B7fpJUJEXGHym7gLzLqVlxvcI6s1iFSlF58gLZL8dlEutzOVimxU0x-t1bvFqpD1xSCiMOM5iSMO7Ljr2ng_u-lJ1RcJkDe7-0pXTWhzlgJvgo7LZpbs8nQumgHg65Q_jflJ8SupXBgHEBZIfJfjatcahm_JFPIsa-inXbXiJWryUerjsGxJ3SnJoD9SSdSXYYELvNDZWRFPpzxR9RhgLN-dP6EzNAXOTolO0yefhYjl4VNcG6IjrGjR7YVIe8n_fimk1vhbU4orvyW-4OSOE5HXNvto-PxHYLSaquZht_yl9KNxpPnzXpl1NAS0VqGyiqjvln2iWLnhTbwtkSsNACrVgIjH3bLtGuz7Q1AFx4MJWEX7nCn23AdMbZ4ZlMVmlz8EOhE-PkWr_7w07iSocjBHH1JAElX_VqRg08o/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://flightadventurepark.com/charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15738754614428749112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flight-adventure-park-charleston",
      "poi_latitude": "32.9619082",
      "poi_longitude": "-80.0445572",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-414-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryQoZXBh_ogROM0QMO9Ja9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6bd6c7fc-98e6-4cda-aa08-7ca6021a442e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7800 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities, including trampolines, bumper cars, and a ropes course. They also highlight the affordable membership options and the fun atmosphere for kids.\n\nOther reviews mention the food can be slow to arrive.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJBzszELFj_ogRnCFEdcWJGDI/photos/AcnlKN1orT9EnI2YxMPHvYdhOUTcO7dZjH4rXt6dC5GKatG2ShW5I9PYcEQMDB4v1uQItSjGWkZehWO2ChowEDGd_Am0Nd33NEpX29xQ9c9sHhbUPU_e3EJArdnevjNc9_50RoTQGx4jEuVH113HPAhP7hlk39AfD2v-dtVCxsSOimKEv0XS0EVnMDL4KL2sfTWu0HrKKHPUNBrUaFaMKhl27AIVbuqIdlRW9Hwgmldpg9NJ1SE2NUXNtX168W-M1zq3yydeTl9A1OnipZ7MTlPuTV6lUqqiRLzVWzIPQYUSykih3VM4bWSIEmqEb6xDskhqwMk8-vF-QJFzok6qyOtCYNrj3aT5EWrlRwhbb59jyIoXmkVSY-K7FU92YF0cIwF2rDNDtlNzibNVBJ0wpxIyPWnuQjEY0WXZruhdqNbd0kAe3w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4000&maxHeightPx=3000",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.urbanair.com/south-carolina-north-charleston/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3609786582506414492&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.9474866",
      "poi_longitude": "-80.03815569999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-737-6775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzszELFj_ogRnCFEdcWJGDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_624d8ea8-a4e5-44b2-8474-c94a4f494bbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Northwoods Stadium Cinema",
      "poi_type": "Entertainment",
      "poi_address": "2181 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Spacious movie theater showing mainstream first-run films, including 3D features.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and a good movie-watching experience. They also highlight the unbeatable prices for tickets and concessions, and the friendly staff.\n\nSome reviews mention the theater can be outdated.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJI-fFW9Bj_ogRWfpxqxq2coY/photos/AcnlKN2PROVL-p0qO1-YrUhWm6LVfLPHQhV96Ehl5xLwRYO1uVywMEs4lUJAOnmCnq9pHrEugSjA2_AjtGQUaX3bmyAInAfehJmFPjgZh4P8M2oqLvo-xsX85BQeiadlC2zyxI0H08f4xVG6kJxUFKLKUI3c2pIl8haa51Ru20mxeg8pXuzi0LAMd_mx0nun5s_gkUfzWMlMGD6ptczes6j9hwHVgJgKO2o_nZMS6qcCw60tebBvDG0Oqw6wtV9AATgEJPVsTQ5O5daq0PgIXjo5za5XVc9hvpu-2BB6xQdE5hSrMw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=640&maxHeightPx=480",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.southeastcinemas.com/movie-theater/northwoodsstadiumcinema",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688005974089136729&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwoods-stadium-cinema",
      "poi_latitude": "32.9403158",
      "poi_longitude": "-80.0440713",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-300-4190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c9-cb9b-75fa-bd64-c3dbf31f1945.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-cb9b-75fa-bd64-c3dbf31f1945",
        "storage_key": "property/6767906449166427/019d02c9-cb9b-75fa-bd64-c3dbf31f1945.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-fFW9Bj_ogRWfpxqxq2coY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b06be7fd-1c64-443d-bd85-05382b50e3e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Stars and Strikes",
      "poi_type": "Entertainment",
      "poi_address": "4570 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Family entertainment center with bowling, arcade games, laser tag, and bumper cars, plus an American restaurant.",
      "poi_long_description": "People say this restaurant offers delicious fried pickles, cocktails, and a variety of games, including bowling, laser tag, and arcade games. They also highlight the fun atmosphere, friendly staff, and the robots that deliver food.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJV7LUTdaJ_ogR6i0H12tQvwU/photos/AcnlKN2sdrFWHZ9H1bh-EEnm-CfuZ26xogOSawjT9vwgTx-GoRyrLD2UkdGbwKTtyCvJkWvohuKt0nK7smIo6ZKOuUByLYIl8lYMuw_IUzxZ9dEzNDXnnTx777rMDtpkOwjiZgEewSVCqo3Kfl1vjK3ZN3-xzQ5oAbLQfm2bbmHgfN1ZQ3HrnEeWWio3PxoelsBoSv1wdfEDwXoB1alPTN3c-9WrqNoB-F_AyerVmnBHp6SLnvCRJ6wTe11Sw7-7kO2TfdoE42Kh9SFAGEkhbg1obDT4Me5uQxMKqAhNDb_NVf-z1g/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1280&maxHeightPx=872",
      "poi_featured_image_media": null,
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=414138114840669674&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "32.9565168",
      "poi_longitude": "-80.1612976",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7LUTdaJ_ogR6i0H12tQvwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_63a1bfec-4dc7-49d4-a879-79c69d2ab97f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Topgolf Charleston",
      "poi_type": "Entertainment",
      "poi_address": "5000 Topgolf Wy, North Charleston, SC 29418, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golf games, delicious food, and strong drinks. They also highlight the lively atmosphere, comfortable bays, and friendly service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJgzTeIedj_ogRKSClP0RCWUQ/photos/AcnlKN0ti4bntP499_ZSE1A-bRNGdb3tGSJNZjVcg3pFOONO-AhzyyKY38GdMOPmthIg18IbP_dWe9uZ6oncT5rWsNaeZIMRmt3t0LuZFtWvdrtriupE5u_4D7FFWRfFIsqQIIwqhtgU3Ish5OHIfvnWriy7V2E1OCr64DbjNqtFwKJ5SZ2VTz25Mhoi_9BhJdrjii2hAWzslUBiQLA93JpW4icMzZ5r6difQkxx64RJtZOjsMkFurIagG3fX72Y7Z4PNKNtsGXk0Oy3gMVXkEpSFwCXgIujnuUGbbtWJ_ObcwErK1St9YrgoraA5DQc0Z5ZQv5fpzfVmtRJaIsNZRR2hy3p3wGL-mvNqe3rvUDTrvCM1JM4eWD_cblTisYaBHM-Qk-zllbGXzsc35g5MWd-RbZo65gxq5IOpOE-CeZ18SM/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4080&maxHeightPx=3072",
      "poi_featured_image_media": null,
      "poi_business_url": "https://topgolf.com/us/charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4925040528399343657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-charleston",
      "poi_latitude": "32.869225",
      "poi_longitude": "-80.016504",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-895-4034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzTeIedj_ogRKSClP0RCWUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0eb2c5d0-114a-412f-8787-125c3edb635f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "6185 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Indoor and outdoor furniture shop with a vast assortment of home decor pieces.",
      "poi_long_description": "People say this home goods store offers a huge selection of items, including seasonal and holiday decor. They also highlight the great prices and friendly, helpful staff.\n\nOther reviews mention the store can be overwhelming.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJB843pZ1j_ogR3ncO2PIu5-8/photos/AcnlKN0p_45oZZeakhVVLtUNOeIlh5E-D4QqSA8NgF9XiChY9I3yDLUXEN1QMCwodrKE48_QAgmClCj4gvEq4Feqsb6jTMQrMrT4WfR1dKvMjwewm0FBfvpcuMyAfOfg4nZWEkxqYJVIQVBvZHL3ZlLa9eA5vRsG2oTd2SyBHTfcvQi3cqkU_jimOTCrRxWg-eXJU8-Np31wXae3jKHNjRPthLqZ3Z8T7wuK_eMVgty5yZF9VBKlN4Mmnda1qGirtRrud9KZIeS6LyMFnbGBN8gmzqhuwstGqQM0sUvaGcR6L7UXrw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1600&maxHeightPx=900",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.athome.com/store/south-carolina-charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17286837315226728414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "32.9063996",
      "poi_longitude": "-80.0243421",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-724-6970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB843pZ1j_ogR3ncO2PIu5-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_1c1ddfe8-3332-4016-996c-22a1b27480fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Rivers Ave Suite 210, North Charleston, SC 29406, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ-dlsdttj_ogR9zOwedCJv9U/photos/AcnlKN08exhkYF1A1Mq6dUG0C7dMAkhE9r4vn41XUVCElNVglmududNw1zlQGJ_O6nz6CX7b6551FzZnQD8LakL29RZJVE5hbFL1yClARPgBsEuEyfmus3g9qHQwb7blujtQ2tC9iMR5JyiIEOf0iNDk975h4Qtjb2L9zv9cGo8_8L41Lg-nheFePQOCJ8LOmhEd4c5ZjmTL2146S3Gnh6xysPgrq_33rZFRCGaso8WdWVGmbDDj6VUTGbJGh9IMOmBD_D-MqkCjCXkVZZShYLmJcfm8qbpa8Pe1QJjBruEz5HX4yaQuy59RWheLOsZTe8sImxINqd90tJ3AwRqEaIw9bzkcXEOAEbYpkCGXxRvejhmEYVvDpOxsdJrDhaVf4hETV9G5_2bQOc_wNLdOqNVccZtagCEPckH-jx75hH4sRqQF5ZZ4/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1600&maxHeightPx=1200",
      "poi_featured_image_media": null,
      "poi_business_url": "https://oldnavy.gap.com/stores/sc/northcharleston/oldnavy-5320.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15402180779118179319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "32.9420949",
      "poi_longitude": "-80.0377068",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-628-5795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-dlsdttj_ogR9zOwedCJv9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_92ce0f36-cb28-4d13-9c78-256921f4dc60",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7250 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products, including fresh produce, snacks, clothing, toiletries, and travel essentials, and is clean, bright, and well-organized.\n\nOther reviews mention the service can be unhelpful and the staff can be impolite.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJX9bcwMNj_ogRwEu2BM0xX8c/photos/AcnlKN0OxwbIfoDTghadie3YXu5LHKbB4q9b-O3tgQhBUy86mjFX5-Nvol--TSF4bReZ_yktEx-2H5R_dxyxnchlnD0hII8aigM89FUqUdbl7hYfd51GeSzoJq-Vr5-pEZ-_E5zrklSj2s4-R0YJSjKZEQaPNprva-kY8KKJlwomhiQNGYVABEtmwoTDDrPJV7QuIMe3iLe3C51qafLmxGhIUqHvz12eCPFOdGJr3s7MwM2sRGXCsrLFtZ0gC5jRECszwMbJr5JigfJXTm_UULEP_n_oBgNas6ilRrTW-EOuawf2YbqpiwqW8Ou78Id_F_q6ewfobiUHfgQtmzeGZXJtrLnvksdIZahTHDEAKNdk9GWPn9uJ8BvA7juc2wdVLknly-Z9dFMf_dEXdbCzliCWpgsJz_LZ7wOB8DEvpbmHlpE/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2448&maxHeightPx=3264",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.target.com/sl/north-charleston/1829",
      "poi_directions_map_url": "https://maps.google.com/?cid=14366256092952284096&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.9354172",
      "poi_longitude": "-80.03604709999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-553-4691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX9bcwMNj_ogRwEu2BM0xX8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_fb8f9d2c-f5c6-4ddd-9cfd-06fa85957afc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2130 Melnick Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and appetizers, and is known for its warm rolls and mozzarella sticks. They also highlight the fun, homey vibe, and the attentive service from the staff.\n\nSome reviews mention there can be a long wait time.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJcRsQenph_ogRN1d3OCaMV9M/photos/AcnlKN3fQNVZCr8rxOBThbGSAz-nbOHSqh1x5r1JQ9A_nWXY2qofeFgI-FGMqObFWYcKKdFzW9mvq4lN2rpRA_e1aLay3enrYBZHMako_iXqSjBb0b9OImzTj5C3HGCJRln-Z2jXMLTwqm-J0Fd3XNi2XSaZIWFMZ7CvUwhsaNUzxCTsXnrQ9U5jqN7_6oAO6S9kx23C0lSCe7M9cyyqJsCvdCV_PxN8QPW3FfLS_mSC0bT7jafPX1C0tj-3RhmBmGU28F6DlQvXIa9it-SCQMjFf7nXFk4xnoUu9B6tbNTG3C-5Vz6oY22c8m_5Nu3cpNwGN8h1fyBGzN4MC5F4CYm6IAWMjBhBK9_ZowHnQ_xuJniuOg_7ol2lmAj3cv2VH8BYVIXiWsIarhv_U-k-pWU10G3fVWTYw4JeoJ8bVCUQ4DcSm2fc/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1079&maxHeightPx=555",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.texasroadhouse.com/locations/south-carolina/n-charleston?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15228794760760612663&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.9618103",
      "poi_longitude": "-80.0457321",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-569-7556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRsQenph_ogRN1d3OCaMV9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_7bfb6eb8-0883-4d08-85bc-2404d6a0060c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "The Grit Counter - North Charleston",
      "poi_type": "Restaurants",
      "poi_address": "3438 W Montague Ave, North Charleston, SC 29418, USA",
      "poi_short_description": "Homestyle grits bowls and other breakfast eats like waffles and biscuits.",
      "poi_long_description": "People say this restaurant serves delicious grit bowls, shrimp and grits, and chicken and waffles. They highlight the generous portions, reasonable prices, and fun atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ92l-OmJj_ogR6yu73GBVWkU/photos/AcnlKN3OMrxO2wSEVkbPVcnESLtz3qhM9g4AhVfpprvS9p62dtTw0fZw0n1g89bbQbeZA7KCUMjA99X4gCYWpxNgkafEVKC3KGCzK1O-TNSnJZPFkBfnTxvKfY5ZZdQCAnQ5SnDglQ-KKrJSDHPOxVj4zafQs_fbcdQjuvWptpizDeMArHc3gNc_oOvaI5iKIa8lwY32zI4aJaTNjTphsC6d2ifuFwsAMR9NHu7eI-J45pCHdQH2eSeA6_C_Qo9lR5aqPNLjVshTfrk2IQoWUdGeM4TzQLNyIJpMoRP9HK417OGmNQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=800&maxHeightPx=800",
      "poi_featured_image_media": null,
      "poi_business_url": "http://gritcounter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4997400611029461995&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-grit-counter---north-charleston",
      "poi_latitude": "32.8638763",
      "poi_longitude": "-80.0228652",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-895-4748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92l-OmJj_ogR6yu73GBVWkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a048dcdb-b316-49c0-abb2-f30652bae91b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "843 Korean BBQ & Sushi House",
      "poi_type": "Restaurants",
      "poi_address": "6601 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Casual eatery offering BBQ beef, pork & veggies cooked on tabletop grills, plus sushi.",
      "poi_long_description": "People say this Korean barbecue restaurant offers delicious bulgogi, sushi, and all-you-can-eat options. They also highlight the fun and engaging atmosphere, and the friendly, attentive service.\n\nOther reviews mention the drinks can be slow.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJmx7Jnpdj_ogRhMM49bt9Pqc/photos/AcnlKN2sjxXGSe6vHuiwg36tqC-n5x9FOT09_hm_Dut6wemfHeMtqd8DKnXqQm_g2rwp6OTD6e7DHmDUk5yWESBE-4FWV6v-7h7CVKmtzgoPeLi1QGTRjbhafkBUuIdxs3UfKz6jhTVX5ZqHJzVax7QORCRxCave1aflRVYk-01Ujg8y3tQzI5PaDdGyrf2ph7uMWPKZ8m166thnOW9lvJk7sxiTV4wBFZWuQANF0ENs1lm77uvR9PbYl9GQV8Ir6kM0qpJzpC6eBGQse26xNfZiD5ehGyJey9pONlMMHU9RL3VI3w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.843koreanbbq.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12051207899116520324&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "843-korean-bbq--sushi-house",
      "poi_latitude": "32.9171395",
      "poi_longitude": "-80.0283671",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-9578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx7Jnpdj_ogRhMM49bt9Pqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_0bf5a235-b29d-44a9-9d0c-72618f7e1ef2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Tiki Taco",
      "poi_type": "Restaurants",
      "poi_address": "7089 Rivers Ave Ste A, North Charleston, SC 29406, USA",
      "poi_short_description": "Tacos, burritos & other Mexican staples offered in an informal venue with bright tropical decor.",
      "poi_long_description": "People say this Mexican restaurant serves authentic and flavorful tacos, quesabirria, and other dishes. They also highlight the reasonable prices and the Taco Tuesday special.\n\nOther reviews mention the seating can be limited.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJhfUXnMBj_ogRKXjQoHHvfp4/photos/AcnlKN1gdXBZjW5lblXoDEH05m-s2CvqcLwH0M3qRfpHJhbHGa9Gt2c_8jcuyHy8tTE75BaO9xG6WCQBrkIPNRyn1yuARe84LamFRoccAji3xfLOKINBbVpYdnAg_5R8FrhCmE877Is_WE9aoRqAwfhcnameuvz2EaqpB0NhGPRzhHoPTk0KWEdfcph3i0B831Xd_dOtL67H2-Bf6mAGuMdPylNN2eceopSGnuW65OQHbeG2R_g1xR1oNHJhm3IoT6qWQNu1tINqFfaUD87BqzzXh66m-sNdrPfBCubCd1mvVLovAXhfcw6qTKaI4AhcoBHi1iSvAXZ5-pUx7H5z0JCGMqHfqb3HA_5AeetPiwRsSJd7Bo7d8l4vJnzBHWUVC9BG9Z3joX1zpd9SDuk5TS_dhEyCFu2s4sT-IYAyc12iXSNZ2A/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "http://rivers.itstikitimeyall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11420828976366516265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tiki-taco",
      "poi_latitude": "32.9278207",
      "poi_longitude": "-80.0349337",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-999-1852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfUXnMBj_ogRKXjQoHHvfp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_1c16786d-bbdc-4b67-93fb-552efaf25c27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Bahama Breeze",
      "poi_type": "Restaurants",
      "poi_address": "7811 Rivers Ave, Charleston, SC 29406, USA",
      "poi_short_description": "Laid-back chain eatery featuring Caribbean entrees & tropical cocktails amid beachy decor.",
      "poi_long_description": "Diners say this Caribbean restaurant serves up delicious coconut shrimp, jerk chicken, and paella. They also highlight the lively and tropical atmosphere, with many enjoying the outdoor dining area and live music.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ3VstYO1j_ogRW8GPUZgjS20/photos/AcnlKN3hHCnAi2If1KOChWjepGDqGQCSOw5kDv9JzxRagnrKc8QaKfL3eapqhYlJbIYSIi_huhKDWE0r6t5hF1RlEculclO1yqLBhc4PcLkl4B7oaFDRdXTXZdXGWru53ogMKzcF1vAWddETQVOZQPU3xgqk8Yct_lHSyOvoaTcZZ1BbHZjhO2QTxsFj9sZx1ReBNFAcFVRfGXJDeyu4jXL1HhxQNYQLUUo5CUATx7xR_jJPv_p7xi73SuEjggXHQEjlTu_GOyfTvCj4bxq4hUwNkX0IjdIVMrrkcQLYIKh16tVB7igW69jbf1_P7p0dx_z8_n6hFzzDmVbNg7jJQSC9jm8IInYnvREF6gUzTAFiLY-0_EHWWckjx5pbHoOfB26-9vN5VYzpYgxOM6vj8Bln9wcWbUSu2Il2KGR3r7IsC6M6x4ifhXDTvcudE_JEug/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3614",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bahamabreeze.com/locations/sc/charleston/north-charleston/3064?cmpid=br:bb_ag:ie_ch:loc_ca:BBGMB_sn:gmb_gt:charleston-sc-3064_pl:locurl_rd:1042",
      "poi_directions_map_url": "https://maps.google.com/?cid=7875427510497821019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bahama-breeze",
      "poi_latitude": "32.9470498",
      "poi_longitude": "-80.04211509999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-405-5779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VstYO1j_ogRW8GPUZgjS20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_50469df9-e209-4276-9fff-bf40fc994ed1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Tanger Outlets Charleston",
      "poi_type": "Shopping & Retail",
      "poi_address": "4840 Tanger Outlet Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Pristine outlet mall featuring brand-name shops for clothes, shoes and home goods, plus a food court and play areas.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, including upscale and luxury brands, and a variety of restaurants. They highlight the clean and well-maintained area, the easy parking, and the relaxed and inviting atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-fcf2-733d-8f35-63cfc634514b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-fcf2-733d-8f35-63cfc634514b",
        "storage_key": "property/6767906449166427/019d02c7-fcf2-733d-8f35-63cfc634514b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/charleston",
      "poi_directions_map_url": "https://maps.google.com/?cid=10411492147648175344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanger-outlets-charleston",
      "poi_latitude": "32.8737687",
      "poi_longitude": "-80.01930109999999",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-529-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE9b7HVtj_ogR8JxWIvIMfZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3c9f3024-4b38-4f6e-9a95-c0e0201c3d80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Northwoods Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2150 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Popular shopping center with a variety of clothing shops, shoe stores and other retailers, plus a food court.",
      "poi_long_description": "People say this shopping center has a great mix of well-known stores and local spots, with a wide selection of brands and items, including clothing, shoes, books, beauty, and jewelry. They also highlight the convenient location, laid-back atmosphere, and clean common areas.\n\nOther reviews mention the bathrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-fe07-7638-9f60-377d8b1ee1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-fe07-7638-9f60-377d8b1ee1e6",
        "storage_key": "property/6767906449166427/019d02c7-fe07-7638-9f60-377d8b1ee1e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shopnorthwoodsmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2504357657666629369&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwoods-mall",
      "poi_latitude": "32.944607",
      "poi_longitude": "-80.044319",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-797-3062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrQ012tBj_ogR-a6_XwVEwSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_08aeb8e3-8ec7-45ae-bcb5-ce2eb23ecf98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Charleston Southern University",
      "poi_type": "Education",
      "poi_address": "9200 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-045a-7533-be7e-9587c23d9fe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-045a-7533-be7e-9587c23d9fe1",
        "storage_key": "property/6767906449166427/019d02c8-045a-7533-be7e-9587c23d9fe1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.charlestonsouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18389572263007151393&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charleston-southern-university",
      "poi_latitude": "32.9821829",
      "poi_longitude": "-80.07065539999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-863-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCTNMZLlh_ogRIeXqg4riNP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1dbadfc7-d1aa-4391-ad94-18ce37caa550",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Trident Technical College",
      "poi_type": "Education",
      "poi_address": "7000 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-0430-7097-8117-e18bcd45be1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-0430-7097-8117-e18bcd45be1e",
        "storage_key": "property/6767906449166427/019d02c8-0430-7097-8117-e18bcd45be1e.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.tridenttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635303724822809317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trident-technical-college",
      "poi_latitude": "32.9280591",
      "poi_longitude": "-80.0307641",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 843-574-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaftirupj_ogR5co7A8udWa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_07413a12-3c37-43c4-9df3-76d2a7ce700b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Berkeley County Library - Hanahan Library",
      "poi_type": "Education",
      "poi_address": "1216 Old Murray Ct, Hanahan, SC 29410, USA",
      "poi_short_description": "Library featuring a kiddie area, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-0965-76ad-8869-8127cf592af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-0965-76ad-8869-8127cf592af0",
        "storage_key": "property/6767906449166427/019d02c8-0965-76ad-8869-8127cf592af0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://berkeleylibrarysc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10780698552306831023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "berkeley-county-library---hanahan-library",
      "poi_latitude": "32.9185954",
      "poi_longitude": "-80.02056879999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-553-0047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOd198cqi5BQRrw7R-Da8nJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0411cb22-3a74-4fc7-a3b2-4b3146618754",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Crunch Fitness - North Charleston",
      "poi_type": "Health and Wellness",
      "poi_address": "7800 Rivers Ave Ste 1300, North Charleston, SC 29406, USA",
      "poi_short_description": "Clean gym chain offering classes and weights.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and workout classes. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1014-77c3-9968-55540cf8f2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1014-77c3-9968-55540cf8f2cc",
        "storage_key": "property/6767906449166427/019d02c8-1014-77c3-9968-55540cf8f2cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/north-charleston",
      "poi_directions_map_url": "https://maps.google.com/?cid=17565199309025101540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---north-charleston",
      "poi_latitude": "32.9465594",
      "poi_longitude": "-80.0376016",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-800-8350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAe-ZiNhj_ogR5MZgB7UfxPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_49790b0e-e576-4e1d-867e-3fc07f4805db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2150 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Chain with cardio, strength training machines, massage chairs, tanning beds, and free pizza.",
      "poi_long_description": "People say this gym offers a wide selection of well-maintained equipment, including cardio machines, weight machines, and free weights, as well as amenities like tanning beds and massage tables. They also highlight the clean facilities, friendly and accommodating staff, and the non-judgmental, enjoyable atmosphere.\n\nOther reviews mention the cardio equipment TVs can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-0e14-738f-a20b-94932b2ab187.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-0e14-738f-a20b-94932b2ab187",
        "storage_key": "property/6767906449166427/019d02c8-0e14-738f-a20b-94932b2ab187.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/north-charleston-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13367494656862933475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.9440316",
      "poi_longitude": "-80.0454944",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-553-2991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZ8wxtBj_ogR41E__5Dhgrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94106dab-a77c-4c85-8e69-284c6d2f1087",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Change Up Cuts Barbershop & Beauty Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5900 Rivers Ave Suite D-4, North Charleston, SC 29406, USA",
      "poi_short_description": "Informal barbershop featuring haircuts, beards, Dominican blowouts, braids, plus nail services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-148c-7021-8111-a14b18ed4c73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-148c-7021-8111-a14b18ed4c73",
        "storage_key": "property/6767906449166427/019d02c8-148c-7021-8111-a14b18ed4c73.webp",
        "width": 1280,
        "height": 1115
      },
      "poi_business_url": "https://www.changeupcuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9284503535833538788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "change-up-cuts-barbershop--beauty-center",
      "poi_latitude": "32.904006",
      "poi_longitude": "-80.01811359999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-789-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7DnCGxj_ogR5GA3QcYu2YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_cc8d92a9-9f26-4426-92b2-3fe4d73e36e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Air Base Fitness & Sports Center",
      "poi_type": "Health and Wellness",
      "poi_address": "205 W Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "Gym, open 24 hours for military card holders, featuring basketball and racquetball courts, along with a cardio room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-14f9-7468-8c75-8ccaba2d88d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-14f9-7468-8c75-8ccaba2d88d8",
        "storage_key": "property/6767906449166427/019d02c8-14f9-7468-8c75-8ccaba2d88d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4000392304379752155&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-base-fitness--sports-center",
      "poi_latitude": "32.8956051",
      "poi_longitude": "-80.0577067",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-963-3347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0VCMuNi_ogR2-7CGJs_hDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e2f9744e-3432-43a5-baef-9bcb57289a23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Against Da Grain (BarberShop)",
      "poi_type": "Health and Wellness",
      "poi_address": "3316 Ashley Phosphate Rd Suite 2, North Charleston, SC 29418, USA",
      "poi_short_description": "Barbershop in Pepperhill Square offering haircuts for men and women in an easygoing setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-14d4-7022-bd45-c4f60509ac10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-14d4-7022-bd45-c4f60509ac10",
        "storage_key": "property/6767906449166427/019d02c8-14d4-7022-bd45-c4f60509ac10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://againstdagrain.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=3653993405344246531",
      "poi_directions_map_url": "https://maps.google.com/?cid=9864131171111936717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "against-da-grain-barbershop",
      "poi_latitude": "32.9306364",
      "poi_longitude": "-80.0725099",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-608-8018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxfDkUBi_ogRzSL8pwlv5Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_414b4779-a8e5-450e-94d0-7da1020208d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "UFLEX Strong House - Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "7355 Cross County Rd, North Charleston, SC 29418, USA",
      "poi_short_description": "Warehouse-style gym featuring a wide array of equipment for serious lifters.",
      "poi_long_description": "People say this gym has a fantastic variety of equipment, with new pieces constantly being added. They also highlight the helpful and friendly atmosphere, making it a great place for fitness enthusiasts.\n\nSome reviews mention the gym can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1a44-702a-adc9-e5444094ee16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1a44-702a-adc9-e5444094ee16",
        "storage_key": "property/6767906449166427/019d02c8-1a44-702a-adc9-e5444094ee16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5187949947407936763&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uflex-strong-house---gym",
      "poi_latitude": "32.924496",
      "poi_longitude": "-80.0739437",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-925-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9gcKY5j_ogR-6zBf_1M_0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bbc8fe1e-5ea0-4fe7-b4d4-140b0269ae19",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Trident Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1a20-72d9-a08b-d269972a5977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1a20-72d9-a08b-d269972a5977",
        "storage_key": "property/6767906449166427/019d02c8-1a20-72d9-a08b-d269972a5977.webp",
        "width": 926,
        "height": 521
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trident-medical-center",
      "poi_latitude": "32.9762786",
      "poi_longitude": "-80.0736211",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3615-7708-b018-b8e4b5fdc61d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3615-7708-b018-b8e4b5fdc61d",
        "storage_key": "property/6767906449166427/019d02c8-3615-7708-b018-b8e4b5fdc61d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_70d92892-253e-478f-8c58-37e5f48a8ede",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "MUSC Health",
      "poi_type": "Health and Wellness",
      "poi_address": "8992 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1b51-70ed-9b3e-cc4cf039565f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1b51-70ed-9b3e-cc4cf039565f",
        "storage_key": "property/6767906449166427/019d02c8-1b51-70ed-9b3e-cc4cf039565f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.muschealth.org/patients-visitors/locations/charleston.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2959624898336810356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "musc-health",
      "poi_latitude": "32.977136",
      "poi_longitude": "-80.06600999999999",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-792-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3615-7708-b018-b8e4b5fdc61d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3615-7708-b018-b8e4b5fdc61d",
        "storage_key": "property/6767906449166427/019d02c8-3615-7708-b018-b8e4b5fdc61d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9LxIb1h_ogRdGXEDSqzEik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_865c2850-d555-46e8-ab3f-eb6d93cb8746",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Magnolia Plantation and Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Charleston, SC 29414, USA",
      "poi_short_description": "Centuries-old plantation known for its romantic gardens, wildlife, and boat tours of a rice field.",
      "poi_long_description": "People say this garden offers a variety of tours, including a nature train, a slavery to freedom tour, and a house tour, as well as a petting zoo, wildlife, and beautiful grounds with azaleas and peacocks. They highlight the peaceful and relaxing atmosphere, and the natural beauty of the swamp and trails. They also like the informative and engaging guides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1b65-770a-9fbd-4215bfc7e598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1b65-770a-9fbd-4215bfc7e598",
        "storage_key": "property/6767906449166427/019d02c8-1b65-770a-9fbd-4215bfc7e598.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.magnoliaplantation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283589237503655207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magnolia-plantation-and-gardens",
      "poi_latitude": "32.8786105",
      "poi_longitude": "-80.0883389",
      "poi_miles_from_property": "22.7",
      "poi_walking_minutes": "8 hours 16 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 843-571-1266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-36ae-70b4-9937-a73d04677d27",
        "storage_key": "property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBX3NdbBi_ogRJ30r0dak2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_ffff27e5-a7b5-48dc-88e3-0f1f2c4f33fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1061 Everglades Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "Riverside park for concerts, festivals, picnics and playground fun, plus military-base relics and memorials.",
      "poi_long_description": "People say this park offers beautiful views of the Cooper River, walking paths, sculptures, and a playground. They highlight the peaceful and clean environment, and the ample green space for picnics and activities. They also like the historical aspects, such as the Naval Memorial and refurbished houses. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1f71-702a-8e78-a802ce470cb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1f71-702a-8e78-a802ce470cb2",
        "storage_key": "property/6767906449166427/019d02c8-1f71-702a-8e78-a802ce470cb2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626706816767301319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverfront-park",
      "poi_latitude": "32.8675754",
      "poi_longitude": "-79.966717",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-308-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-36ae-70b4-9937-a73d04677d27",
        "storage_key": "property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZpkTthk_ogRxxbbwiQ4uHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_17bf91f6-e62b-4c57-a228-342e7838a128",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "North Charleston Wannamaker County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8888 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Park featuring a water park, plus play areas and picnic spots.",
      "poi_long_description": "People say this park offers a splash pad, dog park, trails, and picnic tables. They highlight the clean facilities, ample shelters, and the fun water park area for dogs. They also like the affordable entrance fee and the beautiful, peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-1ff1-7789-9949-242a50ff51d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-1ff1-7789-9949-242a50ff51d3",
        "storage_key": "property/6767906449166427/019d02c8-1ff1-7789-9949-242a50ff51d3.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "http://ccprc.com/1737/North-Charleston-Wannamaker-County-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=557002064498803929&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-charleston-wannamaker-county-park",
      "poi_latitude": "32.9771948",
      "poi_longitude": "-80.0541909",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-762-5585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-36ae-70b4-9937-a73d04677d27",
        "storage_key": "property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pT-qBh_ogR2UScMW3eugc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_35c290ae-15be-4318-ac25-49bcf390e37a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Yeamans Hall Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Yeamans Hall Rd, Hanahan, SC 29410, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-218a-7396-9d07-eb6efefeec1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-218a-7396-9d07-eb6efefeec1d",
        "storage_key": "property/6767906449166427/019d02c8-218a-7396-9d07-eb6efefeec1d.webp",
        "width": 1280,
        "height": 1176
      },
      "poi_business_url": "https://www.yeamanshallclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8830786312155447205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yeamans-hall-club",
      "poi_latitude": "32.9263294",
      "poi_longitude": "-79.97788419999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-744-3351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3996-7795-8de9-8161185bf954.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3996-7795-8de9-8161185bf954",
        "storage_key": "property/6767906449166427/019d02c8-3996-7795-8de9-8161185bf954.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6OOM0Rl_ogRpT9oB11BjXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1c843c5e-8654-45a8-b2c6-65ce3df7db7c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Charleston International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "People say this airport is small, clean, and easy to navigate. They also highlight the friendly and helpful staff, and the efficient security process.\n\nOther reviews mention the baggage claim can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-24e4-75a8-9dd8-d4049afb3013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-24e4-75a8-9dd8-d4049afb3013",
        "storage_key": "property/6767906449166427/019d02c8-24e4-75a8-9dd8-d4049afb3013.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3a3d-755b-85a8-0f496ed7db66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3a3d-755b-85a8-0f496ed7db66",
        "storage_key": "property/6767906449166427/019d02c8-3a3d-755b-85a8-0f496ed7db66.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_807f5912-815c-4446-931b-3d5a9864950d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "North Charleston Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Charleston, SC 29405, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this train station is modern and clean.\n\nOther reviews mention the staff can be unhelpful and impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-25cb-777e-acad-9991bbac52d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-25cb-777e-acad-9991bbac52d0",
        "storage_key": "property/6767906449166427/019d02c8-25cb-777e-acad-9991bbac52d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=13800251795666858073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charleston",
      "poi_latitude": "32.875428",
      "poi_longitude": "-79.99821419999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "111",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3a52-721e-b253-662a59f42316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3a52-721e-b253-662a59f42316",
        "storage_key": "property/6767906449166427/019d02c8-3a52-721e-b253-662a59f42316.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20FxUaNk_ogRWXCrK-RXhL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c4ee3c7b-8ab0-49d8-a250-65c874102a06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "City of North Charleston City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 City Hall Ln, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-260a-741a-b2d9-1551f5300050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-260a-741a-b2d9-1551f5300050",
        "storage_key": "property/6767906449166427/019d02c8-260a-741a-b2d9-1551f5300050.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2612516476197082924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-north-charleston-city-hall",
      "poi_latitude": "32.8766647",
      "poi_longitude": "-80.0118899",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-554-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3ab8-717f-a4da-b45465c009c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3ab8-717f-a4da-b45465c009c4",
        "storage_key": "property/6767906449166427/019d02c8-3ab8-717f-a4da-b45465c009c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1J_3V5j_ogRLBeVteSFQSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c18089b9-e69b-4e06-b47d-ec0f75e41c9c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Roper St. Francis Office Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8536 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-276f-7729-87e0-b1b7136917f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-276f-7729-87e0-b1b7136917f2",
        "storage_key": "property/6767906449166427/019d02c8-276f-7729-87e0-b1b7136917f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rsfh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5175049599877896670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roper-st-francis-office-park",
      "poi_latitude": "32.9674728",
      "poi_longitude": "-80.1088399",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-212-8065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_sQhxqK_ogR3tm_RzF40Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1913b0b2-00cb-4176-8ecb-693e5dce84da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "841st Transportation Battalion (SDDC) HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1050 Remount Rd BLDG 3304, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-29cf-7619-8516-b929039b50c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-29cf-7619-8516-b929039b50c8",
        "storage_key": "property/6767906449166427/019d02c8-29cf-7619-8516-b929039b50c8.webp",
        "width": 938,
        "height": 729
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5207660875602154014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "841st-transportation-battalion-sddc-hq",
      "poi_latitude": "32.905178",
      "poi_longitude": "-79.9736022",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-794-0272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbF-T1dk_ogRHlL3mPlTRUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_df0e2c35-deef-458d-8546-f521baf13cb2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Boeing 88-819 Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5600 Trailwood Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-2b52-70ae-9247-6f96d57325c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-2b52-70ae-9247-6f96d57325c2",
        "storage_key": "property/6767906449166427/019d02c8-2b52-70ae-9247-6f96d57325c2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14126831682227116952&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boeing-88-819-building",
      "poi_latitude": "32.8674185",
      "poi_longitude": "-80.0372312",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUDzNQBj_ogRmJvhXJGWDMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c5adafee-35b9-4cdb-bf8d-000ec70f8985",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Terracon Consultants, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 Reynolds Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-2d4b-71e5-8cc1-547c8d55fb41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-2d4b-71e5-8cc1-547c8d55fb41",
        "storage_key": "property/6767906449166427/019d02c8-2d4b-71e5-8cc1-547c8d55fb41.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.terracon.com/offices/charleston-sc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11915176047361096896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "terracon-consultants-inc",
      "poi_latitude": "32.8594731",
      "poi_longitude": "-79.9694966",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-884-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDw_GJQBl_ogRwHwzW3w1W6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d648a93a-3593-499a-b5b5-8a1f0300f1d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "5041 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious Bang Bang Shrimp, steak, and a variety of fresh seafood dishes, alongside innovative cocktails and an extensive wine list. They also highlight the friendly and attentive service, and the welcoming atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019eb404-1334-727e-9dbf-27bbcb194111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb404-1334-727e-9dbf-27bbcb194111",
        "storage_key": "property/6767906449166427/019eb404-1334-727e-9dbf-27bbcb194111.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/south-carolina/north-charleston/5041-international-blvd.?y_source=1_MTU1MDI4MTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16440838685436424391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "32.8663724",
      "poi_longitude": "-80.01624369999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-747-7735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-321e-75d6-96b4-f3507f1d44b9",
        "storage_key": "property/6767906449166427/019d02c8-321e-75d6-96b4-f3507f1d44b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0TeylZj_ogRxzDwVq2XKeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_4ab850a8-24ab-4d1e-9bba-b461b07a42eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "R.B. Stall High School",
      "poi_type": "Education",
      "poi_address": "3625 Ashley Phosphate Rd, North Charleston, SC 29418, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-9cd9-76df-af2c-58f2812704cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-9cd9-76df-af2c-58f2812704cc",
        "storage_key": "property/6767906449166427/019ef561-9cd9-76df-af2c-58f2812704cc.webp",
        "width": 1280,
        "height": 186
      },
      "poi_business_url": "https://www.ccsdschools.com/stall",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338180560998263456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rb-stall-high-school",
      "poi_latitude": "32.9227581",
      "poi_longitude": "-80.0799828",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaR8mqS1i_ogRoGrizVuXnfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_689d1f44-5be4-4299-a7f0-c3589a2944eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Northwoods Middle School",
      "poi_type": "Education",
      "poi_address": "7763 Northside Dr, North Charleston, SC 29420, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ccsdschools.com/northwoods",
      "poi_directions_map_url": "https://maps.google.com/?cid=11095631829993998939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwoods-middle-school",
      "poi_latitude": "32.9424449",
      "poi_longitude": "-80.05741139999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-2212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWQRUAS1i_ogRW0pPuVya-5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_db0db3d7-b098-4390-b342-2fe8300a31cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Hunley Park Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 Michigan Ave, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-9ea2-743b-8fa4-ce7ef07cb128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-9ea2-743b-8fa4-ce7ef07cb128",
        "storage_key": "property/6767906449166427/019ef561-9ea2-743b-8fa4-ce7ef07cb128.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccsdschools.com/hunleypark",
      "poi_directions_map_url": "https://maps.google.com/?cid=18111817368912653675&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunley-park-elementary-school",
      "poi_latitude": "32.8926725",
      "poi_longitude": "-80.0730605",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-767-5914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-31f9-7349-9591-f8660d8028b2",
        "storage_key": "property/6767906449166427/019d02c8-31f9-7349-9591-f8660d8028b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFVzDYexi_ogRa-3Jvu8ZWvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a83d1ee8-5ba5-4157-95d4-6fd67644292f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Park Circle Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Cir, North Charleston, SC 29405, USA",
      "poi_short_description": "Fenced-in playground with an obstacle course, swings, and slides, plus picnic tables.",
      "poi_long_description": "People say this playground offers a wide variety of unique and interactive equipment, including slides, swings, climbing structures, and a ninja warrior course, suitable for all ages and abilities. Visitors also highlight the extensive shade coverage, soft rubber matting, and clean, well-maintained restrooms. They appreciate the ample seating, picnic tables, and convenient parking options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-a26c-72fa-9ed2-deb779da6894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-a26c-72fa-9ed2-deb779da6894",
        "storage_key": "property/6767906449166427/019ef561-a26c-72fa-9ed2-deb779da6894.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://recreation.northcharleston.org/parks_facilities/park_circle_playground.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=17227418547571913816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "park-circle-playground",
      "poi_latitude": "32.880917",
      "poi_longitude": "-79.9856393",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-740-5809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTpgHABl_ogRWPT_7OQVFO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_f204cc81-aa47-47b5-80be-a45e89656a64",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Hanahan Amphitheater",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3100 Amphitheater Ave, Hanahan, SC 29410, USA",
      "poi_short_description": "Event venue overlooking Goose Creek Reservoir with space for concerts, movies, picnics, and dog walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-a34b-779b-93af-d971a794b5d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-a34b-779b-93af-d971a794b5d7",
        "storage_key": "property/6767906449166427/019ef561-a34b-779b-93af-d971a794b5d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofhanahan.com/recreation-parks/page/amphitheater",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127091158817315011&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hanahan-amphitheater",
      "poi_latitude": "32.9331272",
      "poi_longitude": "-80.0252525",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-266-0723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjemD0etj_ogRwxh6z9vLLLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_ebced3bc-ee0c-4dbf-b260-a35f06052271",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "N. Charleston Superstop",
      "poi_type": "Transportation & Transit",
      "poi_address": "intersection of Rivers Avenue and Cosgrove Avenue, Rivers Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5989826832907687495&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "n-charleston-superstop",
      "poi_latitude": "32.8555841",
      "poi_longitude": "-79.976547",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-ac83-773e-946b-303416a9168d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ef561-ac83-773e-946b-303416a9168d",
        "storage_key": "property/6767906449166427/019ef561-ac83-773e-946b-303416a9168d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdTutTJ7_ogRR9aQ4cQjIFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_e018c2e5-03a2-48e4-b193-b7e5dd75b096",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "113 College Park Rd Ste C & D, Ladson, SC 29456, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-9e96-73ac-85f1-77cd8cefd799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-9e96-73ac-85f1-77cd8cefd799",
        "storage_key": "property/6767906449166427/019ef561-9e96-73ac-85f1-77cd8cefd799.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/summerville-sc/ladson-big-bucks-pawning?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3406370947746929735&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "32.9910203",
      "poi_longitude": "-80.1017636",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eBEnsqK_ogRR5yqSVTcRS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_dbd8b216-f76a-4ef7-bec6-3b339995ec39",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Joint Base Charleston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "102 E Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-9cd4-758b-86b2-5c512b48811a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-9cd4-758b-86b2-5c512b48811a",
        "storage_key": "property/6767906449166427/019ef561-9cd4-758b-86b2-5c512b48811a.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.jbcharleston.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483304259841560535&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "joint-base-charleston",
      "poi_latitude": "32.8974054",
      "poi_longitude": "-80.05202539999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-963-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3ab8-717f-a4da-b45465c009c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3ab8-717f-a4da-b45465c009c4",
        "storage_key": "property/6767906449166427/019d02c8-3ab8-717f-a4da-b45465c009c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z4rC-Vi_ogR1w_ag3jlNz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_1a2a1c02-f7fa-4bd7-916d-d759a13b18b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Bosch Charleston Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8101 Dorchester Rd, Charleston, SC 29418, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef561-9efe-76ac-9dca-1a7607a788e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef561-9efe-76ac-9dca-1a7607a788e6",
        "storage_key": "property/6767906449166427/019ef561-9efe-76ac-9dca-1a7607a788e6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bosch.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13611608346240535530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bosch-charleston-plant",
      "poi_latitude": "32.906213",
      "poi_longitude": "-80.09958329999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-760-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dF6FiqI_ogR6stoa6wl5rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_29357dc2-e032-4476-8337-c74fd5326d95",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "7612 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Customers consistently praise this store for its plentiful selection of electronics and good product display, noting that the staff are knowledgeable and friendly. They also highlight the excellent service and good value provided.\n\nSome reviews mention the service can be inefficient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef573-c4f8-716a-86f6-bbe5598192d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef573-c4f8-716a-86f6-bbe5598192d7",
        "storage_key": "property/6767906449166427/019ef573-c4f8-716a-86f6-bbe5598192d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/sc/north-charleston/7612-rivers-ave-517.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794800529264855175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "32.941519",
      "poi_longitude": "-80.037307",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-553-9299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-3204-75ca-8e9c-ca3594ed80b1",
        "storage_key": "property/6767906449166427/019d02c8-3204-75ca-8e9c-ca3594ed80b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOdyt59pj_ogRh8h3uhT7S14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_79897221-5d88-47ae-92cd-4d3ef9c81256",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "CARTA Route 10 - Rivers Avenue",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rivers Ave / Trident Technical College, North Charleston, SC 29406",
      "poi_short_description": "CARTA fixed-route bus line serving Rivers Avenue. Nearest stop is Rivers Ave / Trident Technical College, adjacent to the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "32.925137",
      "poi_longitude": "-80.032229",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75dcc085-5c6e-4338-af07-c01a5993fceb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "Charles Towne Landing State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500 Old Towne Rd, Charleston, SC 29407, USA",
      "poi_short_description": "Tours & interactive exhibits at the birthplace of the Carolina colony, first settled in 1670.",
      "poi_long_description": "Visitors say this state park offers a unique experience with animal exhibits featuring native animals like red wolves, bears, and pumas, a colonial exhibit with a replica ship, and beautiful walking trails. They also highlight the educational value of the museum and the opportunity to enjoy a relaxing stroll through the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019ef587-7748-722e-93b4-0ff7a9a84441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef587-7748-722e-93b4-0ff7a9a84441",
        "storage_key": "property/6767906449166427/019ef587-7748-722e-93b4-0ff7a9a84441.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://southcarolinaparks.com/charles-towne-landing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12172316460600972251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charles-towne-landing-state-historic-site",
      "poi_latitude": "32.8104054",
      "poi_longitude": "-79.9951397",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-852-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-36ae-70b4-9937-a73d04677d27",
        "storage_key": "property/6767906449166427/019d02c8-36ae-70b4-9937-a73d04677d27.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4MGBJ17_ogR29PCR1TB7Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_cb391fb5-9bf0-4c53-a227-a98d422d9619",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "CARTA Route 11 - Dorchester/Rivers Avenue",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rivers Ave & Cosgrove Ave, North Charleston, SC 29405",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f0623c6-9183-4621-b092-bc9cfa160907",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "poi_name": "North Charleston Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4565 Gaynor Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f068a-403b-714b-a6d2-16ab78884689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f068a-403b-714b-a6d2-16ab78884689",
        "storage_key": "property/6767906449166427/019f068a-403b-714b-a6d2-16ab78884689.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridecarta.com/news-announcements/intermodal-facility-project/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18388241308575805294&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-charleston-transit-center",
      "poi_latitude": "32.8755257",
      "poi_longitude": "-79.9979853",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-14d5c71858f9",
        "storage_key": "property/6767906449166427/019d02c8-35e0-705a-b9cb-14d5c71858f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-Lvgxdl_ogRbi_TiQsoMP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f04f7fed2e76df277f319901",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2ab5b87d457befd469a2b292",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f312d4200905fe28ae168cd3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_62078f54125347f517004afc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bb0fe09397061a21d74897bd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ea6d489de72ecb21c59f86f0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_26251aa5-5d57-481f-a3b4-7f817c4fd49f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "rating": "5.0",
      "name": "Rachel Sigler",
      "text": "I’ve only just moved in but the process has been seamless and any hiccups along the way have been immediately addressed and handled by Alex. He’s welcoming, professional, and efficient— everything you could hope for in a leasing agent. The facility and functions are well maintained and I can already see glimpses of the role he plays in all of that aside from the care he takes with each resident.\nChayla was our consultant who sold us on living here and she has also been wonderful in assessing our lease / onboarding.\nWe are very happy we chose Atlantic on the Avenue and feel very satisfied with the staff present— including maintenance. Despite the limited amount of employees, each person who has regarded us has done so with diligence.",
      "date": "2025-07-07",
      "title": ""
    },
    {
      "id": "custom_191eb8ac-b74a-4bce-aa6d-a37e7232dac6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "rating": "5.0",
      "name": "Danielle Schwenker",
      "text": "This is a beautiful, gem of a complex offering many amenities and fairly new and renovated apartments. I moved here from Long Island and I was shocked and Thrilled I could move somewhere where there is  a CLEAN gym onsite, pool, grill area and washer/ dryer in the unit  with no additional charge and not have to pay an arm and a leg for a facility with such things. Alex was my leasing agent and he was extremely kind, helpful, calm, informative and knowledgeable about the property. He is really dedicated to ensuring the customer experience is smooth and any bumps along the way were addressed with genuine care and attention. He is really good at his job and I definitely recommend going through him to find your new home! Thank you Alex and the Atlantic on the Avenue team.",
      "date": "2025-07-16",
      "title": ""
    },
    {
      "id": "custom_7d8e9933-9a44-4b02-b003-5368eb947bd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "rating": "5.0",
      "name": "Walker",
      "text": "Outstanding.  Impeccably clean around the complex.  I just signed for my first apartment, and the leasing staff was extremely helpful in navigating the process and getting me the best deals possible.\nThe staff clearly take pride in the upkeep of their complex and helping their residents.",
      "date": "2025-08-23",
      "title": ""
    },
    {
      "id": "custom_95623b8d-590e-45d8-899a-cb94a11309c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "rating": "5.0",
      "name": "JASON DRIGGERS",
      "text": "Just moved in here at Atlantic on the Avenue and all the staff and neighbors have been extremely helpful and welcoming. It’s managed well and the grounds are well taken care of. I had an issue with the ceiling fan in the master and maintenance fixed it the very next day.  Shout out to Boomer, the maintenance tech, he was prompt, courteous and professional. I highly recommend the Atlantic in the Avenue to anyone.",
      "date": "2025-05-08",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3de8cd77-afa2-4d28-9be0-9f49ff78bf4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-28f1-719d-8063-612bf901524c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-28f1-719d-8063-612bf901524c",
        "storage_key": "property/6767906449166427/019f6c18-28f1-719d-8063-612bf901524c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=W6UpVuok1BR"
    },
    {
      "id": "custom_270dade5-f66f-4d2a-8f04-ac188822d015",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-28e7-767b-b5a9-6594b78c7787.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-28e7-767b-b5a9-6594b78c7787",
        "storage_key": "property/6767906449166427/019f6c18-28e7-767b-b5a9-6594b78c7787.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=X3XXJtVSVEN"
    },
    {
      "id": "custom_a330bbc7-2d87-411a-ab3b-27e3e6d962cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-291a-7095-b907-c997d74a09fc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-291a-7095-b907-c997d74a09fc",
        "storage_key": "property/6767906449166427/019f6c18-291a-7095-b907-c997d74a09fc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JCcb712NDa1"
    },
    {
      "id": "custom_26e581ea-aeb4-4c03-8b1f-bdd21fc8c280",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-28f4-735e-a20e-40ca526a0f20.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-28f4-735e-a20e-40ca526a0f20",
        "storage_key": "property/6767906449166427/019f6c18-28f4-735e-a20e-40ca526a0f20.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge Patio",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RSNQ9mqS9Du"
    },
    {
      "id": "custom_1eeee4e0-52e7-4538-8095-1b020abb5da9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-29b9-71db-9dc5-d75695a3d450.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-29b9-71db-9dc5-d75695a3d450",
        "storage_key": "property/6767906449166427/019f6c18-29b9-71db-9dc5-d75695a3d450.webp",
        "width": 512,
        "height": 256
      },
      "virtual_tour_title": "Community Tour | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=5b07246cfec4796e1191af86"
    },
    {
      "id": "custom_01704526-1ae7-41b0-ae35-3be54513773a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-2a19-727c-b47a-f76d74acb1f8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-2a19-727c-b47a-f76d74acb1f8",
        "storage_key": "property/6767906449166427/019f6c18-2a19-727c-b47a-f76d74acb1f8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 801 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RdHu5EtS9TY"
    },
    {
      "id": "custom_35906e8f-60fa-4a1a-8a94-fcfb7eedb217",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-28f1-719d-8063-5ed6f68a14b5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-28f1-719d-8063-5ed6f68a14b5",
        "storage_key": "property/6767906449166427/019f6c18-28f1-719d-8063-5ed6f68a14b5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Leasing Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CmTbK2dWpYW"
    },
    {
      "id": "custom_b94da5c8-7c91-4aa0-9d0d-fa5133f1ef8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-2911-70e3-abd5-157046748a8a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-2911-70e3-abd5-157046748a8a",
        "storage_key": "property/6767906449166427/019f6c18-2911-70e3-abd5-157046748a8a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TwjuVC3cft7"
    },
    {
      "id": "custom_6b00f78a-98b1-4a8f-83de-58eff4f6ed2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-28e9-7618-a2cf-26796696322c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-28e9-7618-a2cf-26796696322c",
        "storage_key": "property/6767906449166427/019f6c18-28e9-7618-a2cf-26796696322c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 701 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Lc8Mtr5vBWk"
    },
    {
      "id": "custom_30e620c8-2cff-49e6-a07e-97cc32f2e7a4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019f6c18-2926-758e-a0a8-404b2231a9b8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-2926-758e-a0a8-404b2231a9b8",
        "storage_key": "property/6767906449166427/019f6c18-2926-758e-a0a8-404b2231a9b8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 801 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kPkaVC4g7P7"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfb1-2f18-770f-b68c-e682574dac09",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-atlantic-on-the-avenue-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-north-charleston-sc-atlantic-on-the-avenue",
      "search_query": "pet friendly apartments North Charleston SC",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in North Charleston SC",
      "h2_subtitle": "Discover pet welcoming homes in North Charleston, SC. Atlantic on the Avenue offers ideal spaces for you and your furry friends.",
      "page_copy": "Looking for pet friendly apartments in North Charleston, SC? Atlantic on the Avenue welcomes you and your furry friends with open arms. Our community features a dedicated pet park where your pets can enjoy their own slice of paradise. Choose from one to three-bedroom layouts that cater to both you and your pets' needs. Imagine living in modern, open-concept apartments with amenities that include chef-inspired kitchens and ceiling fans in every room.\n\nAtlantic on the Avenue stands out among pet friendly apartments in North Charleston, SC, by offering not only a comfortable home for you but also catering to the needs of your pets. Our community is equipped with convenient pet-friendly amenities and services. Enjoy a stroll with your pet along the beautifully landscaped paths or take advantage of the nearby parks. Make Atlantic on the Avenue your pet's new favorite place today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments North Charleston SC",
      "seo_description": "Atlantic on the Avenue offers pet friendly apartments in North Charleston, SC with amenities perfect for you and your pet, including a pet park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "luxury-apartments-resort-style-pool-charleston-county-atlantic-on-the-avenue",
      "search_query": "luxury apartments with resort style pool Charleston County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Resort Pool",
      "h2_subtitle": "Find luxury living with a resort-style pool in Charleston County. Atlantic on the Avenue offers the ultimate in upscale apartment living.",
      "page_copy": "Experience luxurious living at Atlantic on the Avenue, where our upscale apartments come with a resort style pool nestled in beautiful Charleston County. This is the place where relaxation and elegance meet, providing residents with more than just a place to live—it's a lifestyle upgrade. Imagine spending sunny afternoons lounging by the pool, soaking up the relaxed ambiance right at your doorstep.\n\nIn addition to the resort style pool, our luxury apartments offer thoughtfully designed floor plans ranging from one to three bedrooms, featuring modern amenities like chef-inspired kitchens and open-concept layouts. Located in North Charleston, Atlantic on the Avenue not only promises a high-end living experience but also easy access to the vibrant cultural and entertainment hubs of Charleston County. Elevate your lifestyle at Atlantic on the Avenue today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Resort Pool in Charleston",
      "seo_description": "Discover luxury apartments with a resort style pool at Atlantic on the Avenue in Charleston County, offering upscale living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-north-charleston-atlantic-on-the-avenue",
      "search_query": "apartments with in unit laundry North Charleston",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in North Charleston",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry in North Charleston. Atlantic on the Avenue offers modern living with ample amenities.",
      "page_copy": "At Atlantic on the Avenue in North Charleston, the convenience of in-unit laundry is just one of the many perks of calling our community home. With thoughtfully designed one to three-bedroom apartments, residents can enjoy the ease of managing laundry from their own units. This means more time to delight in the exciting features our community offers, from our resort-style pool to the 24/7 fitness center.\n\nOur North Charleston apartments boast exceptional living environments, perfect for those seeking both comfort and practicality. In addition to in-unit laundry, the apartments feature modern open-concept layouts, chef-inspired kitchens, and ceiling fans throughout. Atlantic on the Avenue provides an ideal blend of comfort and convenience, allowing you to enjoy both a luxurious home and a superb location close to all North Charleston has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry North Charleston",
      "seo_description": "Atlantic on the Avenue offers apartments with in-unit laundry in North Charleston, providing convenience and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "247-fitness-center-apartments-29406-atlantic-on-the-avenue",
      "search_query": "24/7 fitness center apartments 29406",
      "category": "Amenity",
      "h1_title": "24/7 Fitness Center Apartments in 29406",
      "h2_subtitle": "Stay fit anytime with our 24/7 fitness center in the 29406 area. Atlantic on the Avenue makes healthy living accessible.",
      "page_copy": "For those who prioritize fitness, Atlantic on the Avenue in the 29406 area of North Charleston offers a 24/7 fitness center, providing the convenience you need for maintaining a healthy lifestyle. Whether you're an early riser or a night owl, our fully-equipped gym is available to fit your schedule. This amenity is part of our commitment to offering residents a full, well-rounded living experience that caters to modern lifestyles.\n\nOur community provides more than just a fitness center. Atlantic on the Avenue features spacious one to three-bedroom apartments with open-concept layouts and modern amenities such as chef-inspired kitchens and ceiling fans. Situated in a prime location, our apartments are ideal for those seeking both convenience and a healthy lifestyle. Experience the difference at Atlantic on the Avenue, where fitness and comfort are always at the forefront.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24/7 Fitness Center Apartments in 29406",
      "seo_description": "Atlantic on the Avenue in 29406 offers apartments with a 24/7 fitness center, providing convenience and modern amenities for a healthy lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-chef-inspired-kitchens-north-charleston-atlantic-on-the-avenue",
      "search_query": "apartments with chef inspired kitchens North Charleston",
      "category": "Amenity",
      "h1_title": "Chef-Inspired Kitchen Apartments North Charleston",
      "h2_subtitle": "Discover our apartments in North Charleston with chef-inspired kitchens. Atlantic on the Avenue brings culinary delight home.",
      "page_copy": "Atlantic on the Avenue in North Charleston is the ideal choice for culinary enthusiasts, offering apartments with chef-inspired kitchens designed to elevate your cooking experience. Our modern kitchens feature espresso cabinetry and spacious countertops, providing a premium setup for preparing delicious meals at home. Whether you're a seasoned chef or just enjoy cooking, the thoughtfully designed kitchens in our community are sure to delight!\n\nBeyond the impressive kitchens, our North Charleston apartments offer a variety of layouts from one to three bedrooms, with additional features like open-concept designs and ceiling fans. Residents can also enjoy a suite of amenities, including a resort-style pool, pet park, and a 24/7 fitness center. Atlantic on the Avenue invites you to experience elevated living with culinary comforts in a vibrant North Charleston setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chef-Inspired Kitchen Apartments North Charleston",
      "seo_description": "Experience culinary excellence at Atlantic on the Avenue with our apartments featuring chef-inspired kitchens in North Charleston.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-north-charleston-sc-atlantic-on-the-avenue",
      "search_query": "1 bedroom apartments north charleston sc",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in North Charleston, SC",
      "h2_subtitle": "Explore cozy 1 bedroom apartments in North Charleston, SC. Atlantic on the Avenue provides modern living with prime amenities.",
      "page_copy": "If you're searching for 1 bedroom apartments in North Charleston, SC, look no further than Atlantic on the Avenue. Our thoughtfully designed units provide a perfect blend of comfort and style, boasting open-concept layouts that enhance the flow and space of your living environment. Each apartment is equipped with modern features, including a chef-inspired kitchen and ceiling fans throughout, ensuring a comfortable and stylish home.\n\nLocated in the heart of North Charleston, Atlantic on the Avenue offers easy access to local attractions and conveniences. Residents can also enjoy a range of community amenities such as a resort-style pool, gas grilling stations, and a pet park. Whether you're a busy professional or looking for a peaceful retreat, our 1 bedroom apartments deliver both flexibility and modern conveniences to suit your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments North Charleston, SC",
      "seo_description": "Find modern 1 bedroom apartments at Atlantic on the Avenue in North Charleston, SC. Enjoy stylish living and desirable amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-charleston-county-atlantic-on-the-avenue",
      "search_query": "2 bedroom apartments in charleston county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Charleston County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Charleston County. Atlantic on the Avenue offers comfort and style in a vibrant community.",
      "page_copy": "Atlantic on the Avenue is your destination for spacious 2 bedroom apartments in Charleston County. Our thoughtfully designed floor plans provide ample space and modern amenities, perfect for both small families and individuals desiring extra room. Each apartment boasts a chef-inspired kitchen with espresso cabinetry, making it ideal for cooking enthusiasts.\n\nLocated conveniently in North Charleston, our community combines comfort and convenience with amenities like package lockers, a gas grilling station, and a 24/7 fitness center. Experience life in one of the most desirable areas of Charleston County, where both relaxation and activity are readily available. Choose Atlantic on the Avenue for a modern living experience that's tailored to meet all your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Charleston County",
      "seo_description": "Find your spacious 2 bedroom apartment with modern amenities at Atlantic on the Avenue in Charleston County. Perfect for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-29406-atlantic-on-the-avenue",
      "search_query": "3 bedroom apartments near 29406",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 29406",
      "h2_subtitle": "Explore our elegant 3 bedroom apartments near 29406 at Atlantic on the Avenue. Ideal for families and roommates.",
      "page_copy": "Searching for spacious 3 bedroom apartments near 29406? Atlantic on the Avenue in North Charleston offers beautifully designed units that cater to families and roommates alike. Each apartment features an open-concept layout, making it the perfect choice for those seeking comfort and style. Enjoy a chef-inspired kitchen complete with espresso cabinetry, ideal for family meals and entertaining.\n\nOur community, located conveniently near the 29406 area, offers an array of amenities that include a resort-style pool, gas grilling stations, and a well-equipped 24/7 fitness center. With ceiling fans in every living room and bedroom, you can enjoy a breezy atmosphere all year round. Choose Atlantic on the Avenue for a harmonious blend of luxury and convenience in the heart of North Charleston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 29406",
      "seo_description": "Discover spacious 3 bedroom apartments at Atlantic on the Avenue near 29406. Perfect for families and roommates seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-near-charleston-southern-university-north-charleston",
      "search_query": "apartments near charleston southern university in north charleston",
      "category": "School",
      "h1_title": "Apartments Near Charleston Southern University",
      "h2_subtitle": "Find ideal apartments near Charleston Southern University in North Charleston at Atlantic on the Avenue. Perfect for students and faculty.",
      "page_copy": "Atlantic on the Avenue offers exceptional apartments near Charleston Southern University in North Charleston, providing a convenient living option for both students and faculty. Our community features modern amenities like a 24/7 fitness center and resort-style pool, making it easy to balance work and relaxation.\n\nLocated just a short drive from the university, our apartments feature open-concept layouts and chef-inspired kitchens, creating a comfortable living environment. With easy access to campus facilities and local entertainment, Atlantic on the Avenue is the perfect home base for Charleston Southern University attendees seeking both convenience and a dynamic lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charleston Southern University",
      "seo_description": "Find modern apartments at Atlantic on the Avenue near Charleston Southern University in North Charleston. Ideal for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "rentals-close-to-trident-technical-college-charleston-county",
      "search_query": "rentals close to trident technical college charleston county",
      "category": "School",
      "h1_title": "Rentals Close to Trident Technical College",
      "h2_subtitle": "Discover rentals close to Trident Technical College in Charleston County at Atlantic on the Avenue. Convenient and modern living awaits.",
      "page_copy": "Atlantic on the Avenue offers excellent rentals close to Trident Technical College in Charleston County. Perfectly situated for students and faculty, our community provides easy access to campus and local amenities. Enjoy spacious one to three-bedroom floor plans, each featuring modern touches like ceiling fans and open layouts.\n\nOur community not only boasts proximity to the college but also a variety of amenities, including a pet park and gas grilling stations. Whether you're hitting the books or relaxing after class, Atlantic on the Avenue offers a serene environment that meets your lifestyle needs. Choose us for a seamless blend of convenience and comfort near Trident Technical College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Trident Technical College",
      "seo_description": "Find convenient rentals at Atlantic on the Avenue near Trident Technical College in Charleston County. Ideal for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-near-trident-medical-center-north-charleston",
      "search_query": "apartments near Trident Medical Center North Charleston",
      "category": "Hospital",
      "h1_title": "Apartments Near Trident Medical Center",
      "h2_subtitle": "Explore apartments near Trident Medical Center in North Charleston at Atlantic on the Avenue. Perfect for healthcare professionals.",
      "page_copy": "Atlantic on the Avenue offers stylish apartments near Trident Medical Center in North Charleston, making it an ideal choice for healthcare professionals. Our community provides easy commuting to the medical center while offering a peaceful retreat with resort-style amenities.\n\nChoose from our modern one to three-bedroom floor plans, complete with open-concept layouts and chef-inspired kitchens. Enjoy community features like a 24/7 fitness center and gas grilling stations, providing both convenience and relaxation. Atlantic on the Avenue combines proximity and comfort, catering perfectly to those working at or visiting Trident Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trident Medical Center",
      "seo_description": "Discover modern living at Atlantic on the Avenue near Trident Medical Center in North Charleston. Ideal for healthcare professionals seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "musc-health-adjacent-apartments-charleston-county",
      "search_query": "MUSC Health adjacent apartments Charleston County",
      "category": "Hospital",
      "h1_title": "MUSC Health Adjacent Apartments",
      "h2_subtitle": "Discover MUSC Health adjacent apartments in Charleston County at Atlantic on the Avenue. Perfect for convenient living near healthcare facilities.",
      "page_copy": "At Atlantic on the Avenue, find the perfect living space conveniently located near MUSC Health in Charleston County. Our modern apartments cater to those looking to minimize commute times while enjoying a satisfying living experience. Choose from a variety of floor plans and enjoy amenities such as chef-inspired kitchens and package lockers.\n\nOur community not only offers proximity to MUSC Health but also features a pet park and a fully-equipped fitness center, catering to both work and leisure needs. Atlantic on the Avenue is the ideal choice for healthcare professionals and students seeking easy access to their workplace or college, combined with quality living in Charleston County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "MUSC Health Adjacent Apartments",
      "seo_description": "Find apartments at Atlantic on the Avenue near MUSC Health in Charleston County, ideal for professionals seeking comfort and proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-near-riverfront-park-north-charleston",
      "search_query": "apartments near riverfront park north charleston",
      "category": "Park",
      "h1_title": "Apartments Near Riverfront Park",
      "h2_subtitle": "Experience living in stylish apartments near Riverfront Park in North Charleston. Enjoy both nature and modern amenities at Atlantic on the Avenue.",
      "page_copy": "Welcome to Atlantic on the Avenue, where you can enjoy beautiful apartments near Riverfront Park in North Charleston. This prime location offers easy access to scenic walks and outdoor activities, making it perfect for nature lovers and active individuals alike.\n\nOur community provides a selection of one to three-bedroom floor plans featuring open-concept designs and chef-inspired kitchens. Amenities such as a gas grilling station and a pet park enhance your living experience. Whether you're relaxing at home or enjoying the nearby park, Atlantic on the Avenue offers a unique combination of urban convenience and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverfront Park",
      "seo_description": "Discover Atlantic on the Avenue, offering modern apartments near Riverfront Park in North Charleston. Perfect blend of convenience and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166427",
      "source": "generator",
      "page_item_url": "apartments-close-to-wannamaker-county-park",
      "search_query": "apartments close to north charleston wannamaker county park",
      "category": "Park",
      "h1_title": "Apartments Close to Wannamaker Park",
      "h2_subtitle": "Explore living in apartments close to North Charleston Wannamaker County Park. Enjoy the perfect mix of nature and modern living at Atlantic on the Avenue.",
      "page_copy": "Atlantic on the Avenue offers an exceptional living experience with apartments close to North Charleston Wannamaker County Park. Ideal for those who love spending time outdoors, our community is just a short drive away from this beautiful park, providing endless scenic trails and recreational opportunities.\n\nChoose from a range of thoughtfully designed floor plans, complete with modern amenities like chef-inspired kitchens and ceiling fans in every room. Whether you're spending your day at the park or enjoying the comforts of our community, including a fitness center and pet park, Atlantic on the Avenue offers idyllic living near the best of North Charleston's natural attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
      "featured_image_media": {
        "alt_text": "ADA accessibility symbol",
        "public_id": "019d02c7-ed49-708b-b487-6432ee859c70",
        "storage_key": "property/6767906449166427/019d02c7-ed49-708b-b487-6432ee859c70.webp",
        "width": 30,
        "height": 21
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Wannamaker Park",
      "seo_description": "Find your home at Atlantic on the Avenue, near Wannamaker County Park in North Charleston. Enjoy modern living with nearby natural amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5297"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425162"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=6fa416db54c15f13b0cef9fecef49d08c111a631262e0fb23dbd5a37714a3c33b871f761a0c8da5a9471af275442778d\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PXCX8QHX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "832ATA"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40256880238"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "119370"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Atlantic on the Avenue/scheduletourwidget/ErlumMy2QQl6hmkt5v/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkdON0xmOTlPNGNEckwvak5RVmhRcGc9PSIsInZhbHVlIjoiUFlYTkhoTEYwYm1JSzFzSHFYZXM3Zz09IiwibWFjIjoiMGRjOWJmYTdmYjk0MmI5OGM5NmU1NDIzODY5NjEyYTM1OWRlZmUxZTc2YmZlOGZkZTJhMWJkNjk2YjAwZWQ0ZSJ9"
    }
  ],
  "custom_qb_id": "5297",
  "custom_repli_id": "18104425162",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=6fa416db54c15f13b0cef9fecef49d08c111a631262e0fb23dbd5a37714a3c33b871f761a0c8da5a9471af275442778d\"></script>",
  "custom_google_gtm_id": "GTM-PXCX8QHX",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "832ATA",
  "custom_hubspot_company_id": "40256880238",
  "custom_broker_license_number": "119370",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Atlantic on the Avenue/scheduletourwidget/ErlumMy2QQl6hmkt5v/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkdON0xmOTlPNGNEckwvak5RVmhRcGc9PSIsInZhbHVlIjoiUFlYTkhoTEYwYm1JSzFzSHFYZXM3Zz09IiwibWFjIjoiMGRjOWJmYTdmYjk0MmI5OGM5NmU1NDIzODY5NjEyYTM1OWRlZmUxZTc2YmZlOGZkZTJhMWJkNjk2YjAwZWQ0ZSJ9",
  "custom_audioeye_site_id": "8edf8adf-c457-4855-9936-c7f214095589",
  "custom_audioeye_site_hash": "74c6ebb1ad2452d6c0657a6ea0421bdb"
};

export const generatedAt = '2026-08-21T22:00:28.176Z';
